/* eslint-disable */
/**
 * Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:fms` or
 *    `npm run generate:graphql:fms:local` in the terminal
 */

export type Maybe<T> = T | null | undefined
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** An ISO 8601-encoded date */
  ISO8601Date: any
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: string
  /** Represents untyped JSON */
  JSON: any
}

export type IAccessorialShipperFacility = {
  __typename?: 'AccessorialShipperFacility'
  id: Scalars['ID']
  uuid: Scalars['ID']
}

export enum IAccessorialSourceInputEnum {
  /** FLEET_PLANNER */
  fleet_planner = 'fleet_planner',
  /** MOBILE */
  mobile = 'mobile',
}

export type IActivity = {
  __typename?: 'Activity'
  actor?: Maybe<IActivityActor>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  metadata: Scalars['JSON']
  shipment: IShipment
  type: IActivityTypes
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** Objects which may be the actor of an activity */
export type IActivityActor = IDispatcher | IDriver

/** The connection type for Activity. */
export type IActivityConnection = {
  __typename?: 'ActivityConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IActivityEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IActivity>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IActivityEdge = {
  __typename?: 'ActivityEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IActivity>
}

export enum IActivityTypes {
  DriverVerifiedV1 = 'DriverVerifiedV1',
  ShareableSharedV1 = 'ShareableSharedV1',
  ShipmentCheckInTimeUpdatedV1 = 'ShipmentCheckInTimeUpdatedV1',
  ShipmentCheckOutTimeUpdatedV1 = 'ShipmentCheckOutTimeUpdatedV1',
  ShipmentCreatedV1 = 'ShipmentCreatedV1',
  ShipmentImportedV1 = 'ShipmentImportedV1',
  ShipmentImportedV2 = 'ShipmentImportedV2',
  ShipmentStatusUpdatedV1 = 'ShipmentStatusUpdatedV1',
  ShipmentStatusUpdatedV2 = 'ShipmentStatusUpdatedV2',
  ShipmentStatusUpdatedV3 = 'ShipmentStatusUpdatedV3',
  ShipmentStatusUpdatedV4 = 'ShipmentStatusUpdatedV4',
}

export type IAddress = {
  __typename?: 'Address'
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  addressee?: Maybe<Scalars['String']>
  countryCode?: Maybe<Scalars['String']>
  displayTimezone?: Maybe<Scalars['String']>
  locality?: Maybe<Scalars['String']>
  postalCode?: Maybe<Scalars['String']>
  subdivisionCode?: Maybe<Scalars['String']>
}

/** Attributes for generic file uploads */
export type IAttachableFileInput = {
  /** base64 encoded file */
  file: Scalars['String']
  fileFileName: Scalars['String']
}

/** File uploads specific to shipment detention requests */
export type IAttachmentInput = {
  /** base64 encoded file */
  file: Scalars['String']
  fileFileName: Scalars['String']
  fileType: IFileTypeInputEnum
}

export type IAuctionShipment = {
  __typename?: 'AuctionShipment'
  deliveryCity: Scalars['String']
  deliveryStateCode: Scalars['String']
  deliveryTimes: Array<Scalars['ISO8601DateTime']>
  deliveryTimezone: Scalars['String']
  distance: Scalars['Float']
  equipmentName: Scalars['String']
  equipmentParentId: Scalars['ID']
  pickupCity: Scalars['String']
  pickupStateCode: Scalars['String']
  pickupTimes: Array<Scalars['ISO8601DateTime']>
  pickupTimezone: Scalars['String']
  rate: Scalars['Float']
  shipmentId: Scalars['ID']
  unviewed?: Maybe<Scalars['Boolean']>
  weight: Scalars['Int']
}

/** The connection type for AuctionShipment. */
export type IAuctionShipmentConnection = {
  __typename?: 'AuctionShipmentConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IAuctionShipmentEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IAuctionShipment>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IAuctionShipmentEdge = {
  __typename?: 'AuctionShipmentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IAuctionShipment>
}

export type IBrokerCarrierAgreement = {
  __typename?: 'BrokerCarrierAgreement'
  id: Scalars['ID']
}

export type ICarrierApplication = {
  __typename?: 'CarrierApplication'
  brokerCarrierAgreement?: Maybe<IBrokerCarrierAgreement>
  carrierScorecard?: Maybe<ICarrierScorecard>
  fleetPlannerMotorCarrierId?: Maybe<Scalars['ID']>
  hasInsurance?: Maybe<Scalars['Boolean']>
  hasW9?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  name: Scalars['String']
  safetyLetterNeeded: Scalars['Boolean']
  state: ICarrierApplicationStates
}

export enum ICarrierApplicationStates {
  /** Active */
  activated = 'activated',
  /** App. Submitted */
  application_submitted = 'application_submitted',
  /** Cancelled */
  cancelled = 'cancelled',
  /** Conditional */
  conditional = 'conditional',
  /** Cannot Use */
  do_not_use = 'do_not_use',
  /** Expired Ins. */
  expired_insurance = 'expired_insurance',
  /** In Review */
  in_review = 'in_review',
  /** Fresh */
  new = 'new',
  /** Other */
  other = 'other',
  /** Out of Service */
  out_of_service = 'out_of_service',
  /** Pending */
  pending = 'pending',
  /** Probation */
  probation = 'probation',
}

export type ICarrierScorecard = {
  __typename?: 'CarrierScorecard'
  /** Number of times the carrier fell off a shipment within 24 hours of pickup */
  bounceFailure?: Maybe<Scalars['Int']>
  /** Bounce Percentage of the carrier */
  bouncePct?: Maybe<Scalars['Float']>
  /** Bounce score of the carrier */
  bounceScore?: Maybe<Scalars['Int']>
  /** Number of times the carrier did not fall off a shipment within 24 hour of pickup */
  bounceSuccess?: Maybe<Scalars['Int']>
  /** Number of stops arrived late */
  onTimeFailure?: Maybe<Scalars['Int']>
  /** On Time Percentage of the carrier */
  onTimePct: Scalars['Float']
  /** On time score for the carrier */
  onTimeScore?: Maybe<Scalars['Int']>
  /** Number of stops arrived on-time */
  onTimeSuccess?: Maybe<Scalars['Int']>
  /** Overall score for the carrier */
  overallScore?: Maybe<Scalars['Float']>
  /** If the scorecard holds stale data */
  stale?: Maybe<Scalars['Boolean']>
  /** Number of shipments not tracked */
  trackingFailure?: Maybe<Scalars['Int']>
  /** Tracking Percentage of the carrier */
  trackingPct: Scalars['Float']
  /** Tracking score for the carrier */
  trackingScore?: Maybe<Scalars['Int']>
  /** Number of shipments tracked */
  trackingSuccess?: Maybe<Scalars['Int']>
  /** Date the carrier scorecard was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>
}

export enum ICertificationCode {
  /** alaska native corporation or indian tribe */
  anc_indian_tribe = 'anc_indian_tribe',
  /** disadvantaged business */
  dbe = 'dbe',
  /** disabled owned business */
  disabled = 'disabled',
  /** economically disadvantaged women owned small business */
  edwosb = 'edwosb',
  /** 8(a) business development program */
  eight_a = 'eight_a',
  /** historically black colleges and universities */
  hbcu = 'hbcu',
  /** lesbian, gay, bisexual, and transgender */
  lgbt = 'lgbt',
  /** minority owned business */
  mbe = 'mbe',
  /** small disadvantaged business */
  sdb = 'sdb',
  /** service-disabled veteran-owned small business */
  sdvet = 'sdvet',
  /** small business */
  small = 'small',
  /** veteran owned business */
  vet = 'vet',
  /** women owned business */
  wbe = 'wbe',
  /** women owned small business */
  wosb = 'wosb',
}

export enum ICodeStatuses {
  /** active */
  active = 'active',
  /** failed */
  failed = 'failed',
  /** inactive */
  inactive = 'inactive',
  /** pending */
  pending = 'pending',
  /** processing */
  processing = 'processing',
  /** used */
  used = 'used',
}

export enum ICodeTypes {
  /** Digital Card */
  digital_card = 'digital_card',
  /** Relay Code */
  relay_code = 'relay_code',
}

export type IComplianceChecklist = {
  __typename?: 'ComplianceChecklist'
  hasW9Form: Scalars['Boolean']
  id: Scalars['ID']
  motorCarrierId: Scalars['ID']
}

export type IComplianceFlag = {
  __typename?: 'ComplianceFlag'
  description: Scalars['String']
  id: Scalars['ID']
  name: Scalars['String']
}

export type IContact = {
  __typename?: 'Contact'
  contactableId: Scalars['ID']
  contactableType: Scalars['String']
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  email?: Maybe<Scalars['String']>
  entityId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  phoneExt?: Maybe<Scalars['String']>
  purpose: Scalars['String']
  sourceContactId?: Maybe<Scalars['ID']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum ICountries {
  /** Canada */
  CA = 'CA',
  /** Mexico */
  MX = 'MX',
  /** United States */
  US = 'US',
}

/** Autogenerated input type of CreateAccessorialDocument */
export type ICreateAccessorialDocumentInput = {
  accessorialId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  documents: Array<IAttachableFileInput>
}

/** Autogenerated return type of CreateAccessorialDocument */
export type ICreateAccessorialDocumentPayload = {
  __typename?: 'CreateAccessorialDocumentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success?: Maybe<Scalars['Boolean']>
}

/** Autogenerated input type of CreateDispatcher */
export type ICreateDispatcherInput = {
  cellPhone: Scalars['String']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  motorCarrierId: Scalars['ID']
  phone: Scalars['String']
  role: IUserRoleEnum
}

/** Autogenerated return type of CreateDispatcher */
export type ICreateDispatcherPayload = {
  __typename?: 'CreateDispatcherPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  dispatcher?: Maybe<IDispatcher>
  errors?: Maybe<Array<IError>>
}

/** Autogenerated input type of CreateDriver */
export type ICreateDriverInput = {
  cellPhone: Scalars['String']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  motorCarrierId: Scalars['ID']
}

/** Autogenerated return type of CreateDriver */
export type ICreateDriverPayload = {
  __typename?: 'CreateDriverPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  driver?: Maybe<IDriver>
  errors?: Maybe<Array<IError>>
}

/** Autogenerated input type of CreateLumperRelayPayments */
export type ICreateLumperRelayPaymentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  constraintAmount: Scalars['Float']
  shipmentId: Scalars['ID']
  stopId: Scalars['ID']
}

/** Autogenerated return type of CreateLumperRelayPayments */
export type ICreateLumperRelayPaymentsPayload = {
  __typename?: 'CreateLumperRelayPaymentsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipmentAccessorialId?: Maybe<Scalars['ID']>
}

/** Autogenerated input type of CreateMotorCarrierBca */
export type ICreateMotorCarrierBcaInput = {
  brokerCarrierSignatory: Scalars['String']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  contactEmail: Scalars['String']
  motorCarrierId: Scalars['ID']
}

/** Autogenerated return type of CreateMotorCarrierBca */
export type ICreateMotorCarrierBcaPayload = {
  __typename?: 'CreateMotorCarrierBcaPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  motorCarrier?: Maybe<IMotorCarrier>
}

/** Autogenerated input type of CreateMotorCarrierComplianceFlag */
export type ICreateMotorCarrierComplianceFlagInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  flagName?: Maybe<Scalars['String']>
  motorCarrierId: Scalars['ID']
}

/** Autogenerated return type of CreateMotorCarrierComplianceFlag */
export type ICreateMotorCarrierComplianceFlagPayload = {
  __typename?: 'CreateMotorCarrierComplianceFlagPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  motorCarrierComplianceFlag?: Maybe<IMotorCarrierComplianceFlag>
}

/** Autogenerated input type of CreateMotorCarrier */
export type ICreateMotorCarrierInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** Required if no mc_number is provided. */
  dotNumber?: Maybe<Scalars['Int']>
  /** Required if no dot_number is provided. */
  mcNumber?: Maybe<Scalars['Int']>
}

/** Autogenerated input type of CreateMotorCarrierInsuranceContacts */
export type ICreateMotorCarrierInsuranceContactsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  insuranceContacts: Array<IMotorCarrierInsuranceContactInput>
}

/** Autogenerated return type of CreateMotorCarrierInsuranceContacts */
export type ICreateMotorCarrierInsuranceContactsPayload = {
  __typename?: 'CreateMotorCarrierInsuranceContactsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  insuranceContacts?: Maybe<Array<IMotorCarrierInsuranceContact>>
}

/** Autogenerated return type of CreateMotorCarrier */
export type ICreateMotorCarrierPayload = {
  __typename?: 'CreateMotorCarrierPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  motorCarrier?: Maybe<IMotorCarrier>
}

/** Autogenerated input type of CreateOwnerOperator */
export type ICreateOwnerOperatorInput = {
  cellPhone: Scalars['String']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  motorCarrierId: Scalars['ID']
  phone: Scalars['String']
  role: IUserRoleEnum
}

/** Autogenerated return type of CreateOwnerOperator */
export type ICreateOwnerOperatorPayload = {
  __typename?: 'CreateOwnerOperatorPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors?: Maybe<Array<IError>>
  ownerOperator?: Maybe<IOwnerOperator>
}

/** Autogenerated input type of CreateRulesAssessmentOverrides */
export type ICreateRulesAssessmentOverridesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  motorCarrierId: Scalars['ID']
  rulesAssessmentOverrides: Array<IUpdateRulesAssessmentOverride>
  transfixUserId: Scalars['ID']
}

/** Autogenerated return type of CreateRulesAssessmentOverrides */
export type ICreateRulesAssessmentOverridesPayload = {
  __typename?: 'CreateRulesAssessmentOverridesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors?: Maybe<Array<IError>>
  rulesAssessmentOverrides?: Maybe<Array<IRulesAssessmentOverride>>
}

/** Autogenerated input type of CreateSafetyLetter */
export type ICreateSafetyLetterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  driverRatingSummary: Scalars['String']
  motorCarrierId: Scalars['ID']
  safetyLetterSignatory: Scalars['String']
  safetyLetterSignatoryTitle: Scalars['String']
  vehicleRatingSummary: Scalars['String']
}

/** Autogenerated return type of CreateSafetyLetter */
export type ICreateSafetyLetterPayload = {
  __typename?: 'CreateSafetyLetterPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of CreateSavedSearch */
export type ICreateSavedSearchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  deliveryCity?: Maybe<Scalars['String']>
  deliveryEndDate?: Maybe<Scalars['ISO8601Date']>
  deliveryMiles?: Maybe<Scalars['Float']>
  deliveryStartDate?: Maybe<Scalars['ISO8601Date']>
  deliveryStateCode?: Maybe<Scalars['String']>
  dropTrailer?: Maybe<Scalars['Boolean']>
  hasNotificationsEnabled?: Maybe<Scalars['Boolean']>
  hasPushNotificationsEnabled?: Maybe<Scalars['Boolean']>
  loadedMilesMax?: Maybe<Scalars['Float']>
  loadedMilesMin?: Maybe<Scalars['Float']>
  motorCarrierId?: Maybe<Scalars['ID']>
  pickupCity: Scalars['String']
  pickupEndDate?: Maybe<Scalars['ISO8601Date']>
  pickupIsoDaysOfWeek?: Maybe<Array<Scalars['Int']>>
  pickupMiles?: Maybe<Scalars['Float']>
  pickupStartDate?: Maybe<Scalars['ISO8601Date']>
  pickupStateCode: Scalars['String']
  rate?: Maybe<Scalars['Float']>
  rateType?: Maybe<Scalars['String']>
  trailerType?: Maybe<Scalars['String']>
}

/** Autogenerated return type of CreateSavedSearch */
export type ICreateSavedSearchPayload = {
  __typename?: 'CreateSavedSearchPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  savedSearch?: Maybe<ISavedSearch>
}

/** Autogenerated input type of CreateTrailer */
export type ICreateTrailerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  motorCarrierId: Scalars['ID']
  trailerLength?: Maybe<Scalars['String']>
  trailerNumber: Scalars['String']
  trailerType?: Maybe<Scalars['String']>
}

/** Autogenerated return type of CreateTrailer */
export type ICreateTrailerPayload = {
  __typename?: 'CreateTrailerPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  trailer?: Maybe<ITrailer>
}

/** Autogenerated input type of CreateTruck */
export type ICreateTruckInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  entityId?: Maybe<Scalars['ID']>
  keepTruckinId?: Maybe<Scalars['ID']>
  motorCarrierId: Scalars['ID']
  truckNumber: Scalars['String']
  vin?: Maybe<Scalars['String']>
}

/** Autogenerated input type of CreateTruckLocations */
export type ICreateTruckLocationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  truckLocations: Array<ITruckLocationInput>
}

/** Autogenerated return type of CreateTruckLocations */
export type ICreateTruckLocationsPayload = {
  __typename?: 'CreateTruckLocationsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors?: Maybe<Array<IError>>
  keepTracking?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of CreateTruck */
export type ICreateTruckPayload = {
  __typename?: 'CreateTruckPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors?: Maybe<Array<IError>>
  truck?: Maybe<ITruck>
}

export type ICurrentShipment = {
  __typename?: 'CurrentShipment'
  id: Scalars['ID']
  startAt: Scalars['ISO8601DateTime']
  trackingSummary: IShipmentTrackingSummary
}

export type ICustomer = {
  __typename?: 'Customer'
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
}

export type ICustomerContact = {
  __typename?: 'CustomerContact'
  email?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  purpose?: Maybe<IPurposeCustomer>
}

/** Autogenerated input type of DeactivateRelayPayment */
export type IDeactivateRelayPaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** the relay_payments_code record id to be deactivated */
  relayPaymentsCodeId: Scalars['ID']
  /** the shipment id to determine if user is associated to the shipment */
  shipmentId: Scalars['ID']
}

/** Autogenerated return type of DeactivateRelayPayment */
export type IDeactivateRelayPaymentPayload = {
  __typename?: 'DeactivateRelayPaymentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  result: Scalars['Boolean']
}

/** Autogenerated input type of DeclineShipment */
export type IDeclineShipmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  marketplaceId: Scalars['ID']
}

/** Autogenerated return type of DeclineShipment */
export type IDeclineShipmentPayload = {
  __typename?: 'DeclineShipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IMarketplaceShipment>
}

/** Autogenerated input type of DeleteMotorCarrierCertification */
export type IDeleteMotorCarrierCertificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  code: ICertificationCode
  motorCarrierId: Scalars['ID']
}

/** Autogenerated return type of DeleteMotorCarrierCertification */
export type IDeleteMotorCarrierCertificationPayload = {
  __typename?: 'DeleteMotorCarrierCertificationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  motorCarrier?: Maybe<IMotorCarrier>
}

/** Autogenerated input type of DeleteSavedSearchSubscriber */
export type IDeleteSavedSearchSubscriberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  savedSearchId: Scalars['ID']
}

/** Autogenerated return type of DeleteSavedSearchSubscriber */
export type IDeleteSavedSearchSubscriberPayload = {
  __typename?: 'DeleteSavedSearchSubscriberPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of DeleteUserAccount */
export type IDeleteUserAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
}

/** Autogenerated return type of DeleteUserAccount */
export type IDeleteUserAccountPayload = {
  __typename?: 'DeleteUserAccountPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

/** this is a digital card */
export type IDigitalCardDetails = {
  __typename?: 'DigitalCardDetails'
  cardNumber?: Maybe<Scalars['String']>
  cvv?: Maybe<Scalars['String']>
  expireMonth?: Maybe<Scalars['Int']>
  expireYear?: Maybe<Scalars['Int']>
}

/** Autogenerated input type of DispatchShipment */
export type IDispatchShipmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  eta?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
}

/** Autogenerated return type of DispatchShipment */
export type IDispatchShipmentPayload = {
  __typename?: 'DispatchShipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  shipment?: Maybe<IShipment>
}

export type IDispatcher = {
  __typename?: 'Dispatcher'
  cellPhone?: Maybe<Scalars['String']>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  email: Scalars['String']
  firstName: Scalars['String']
  fullName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  lastName: Scalars['String']
  marketplaceId: Scalars['ID']
  maskedEmail: Scalars['String']
  motorCarrierId: Scalars['ID']
  phone: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IDownloadable = {
  __typename?: 'Downloadable'
  name: Scalars['String']
  url?: Maybe<Scalars['String']>
}

export type IDriver = {
  __typename?: 'Driver'
  cellPhone: Scalars['String']
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  email?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  lastName?: Maybe<Scalars['String']>
  marketplaceId: Scalars['ID']
  motorCarrierId: Scalars['ID']
  name?: Maybe<Scalars['String']>
  shipmentDrivers: Array<IShipmentDriver>
  smsStatusUpdatesEnabled: Scalars['Boolean']
  transfixUserId?: Maybe<Scalars['ID']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export enum IEquipmentTypes {
  dry_van = 'dry_van',
  flatbed = 'flatbed',
  open_deck = 'open_deck',
  reefer = 'reefer',
  specialized = 'specialized',
}

export type IError = {
  __typename?: 'Error'
  key: Scalars['String']
  message: Scalars['String']
}

export type IEtaObject = {
  __typename?: 'EtaObject'
  drivingDistance: Scalars['Float']
  eta: Scalars['ISO8601DateTime']
  lastPingLatitude: Scalars['Float']
  lastPingLongitude: Scalars['Float']
  onTime: Scalars['Boolean']
  shipmentId: Scalars['ID']
}

export enum IFileTypeInputEnum {
  /** INVOICE */
  invoice = 'invoice',
  /** POD */
  pod = 'pod',
  /** RATE_CON */
  rate_con = 'rate_con',
}

/** GeocoderHelper Response */
export type IGeocoding = {
  __typename?: 'Geocoding'
  address?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  coordinates: Array<Scalars['Float']>
  country?: Maybe<Scalars['String']>
  countryCode?: Maybe<Scalars['String']>
  id: Scalars['ID']
  latitude: Scalars['Float']
  longitude: Scalars['Float']
  postalCode?: Maybe<Scalars['String']>
  resultType?: Maybe<Scalars['String']>
  shortString?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  stateCode?: Maybe<Scalars['String']>
}

export enum IGeocodingAllowedCountryEnum {
  /** CA */
  CA = 'CA',
  /** MX */
  MX = 'MX',
  /** US */
  US = 'US',
}

export enum IGeocodingResultTypeEnum {
  /** Address */
  Address = 'Address',
  /** City */
  City = 'City',
  /** Country */
  Country = 'Country',
  /** Poi */
  POI = 'POI',
  /** Postalcode */
  PostalCode = 'PostalCode',
  /** State */
  State = 'State',
}

/** Autogenerated input type of GuidedBid */
export type IGuidedBidInput = {
  bidAmount: Scalars['Float']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  marketplaceId: Scalars['ID']
  sourceChannel: Scalars['String']
  sourceSegment: Scalars['String']
}

/** Autogenerated return type of GuidedBid */
export type IGuidedBidPayload = {
  __typename?: 'GuidedBidPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  result?: Maybe<Scalars['String']>
}

export type IHighwayAddress = {
  __typename?: 'HighwayAddress'
  city?: Maybe<Scalars['String']>
  countryCode?: Maybe<Scalars['String']>
  createdAt: Scalars['ISO8601DateTime']
  id?: Maybe<Scalars['ID']>
  isType: Scalars['String']
  postalCode?: Maybe<Scalars['String']>
  stateCode?: Maybe<Scalars['String']>
  street1?: Maybe<Scalars['String']>
  street2?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type IHighwayCarrier = {
  __typename?: 'HighwayCarrier'
  addresses: Array<IHighwayAddress>
  brokerAuthority?: Maybe<Scalars['String']>
  contacts: Array<IHighwayContact>
  continuousAuthorityGrantDate?: Maybe<Scalars['ISO8601Date']>
  createdAt: Scalars['ISO8601DateTime']
  dbaName?: Maybe<Scalars['String']>
  dotNumber?: Maybe<Scalars['Int']>
  driverOosInspections?: Maybe<Scalars['Int']>
  ein?: Maybe<Scalars['String']>
  fatalCrashes?: Maybe<Scalars['Int']>
  fmcsaContactPhone?: Maybe<Scalars['String']>
  highwayId: Scalars['ID']
  id: Scalars['ID']
  injuryCrashes?: Maybe<Scalars['Int']>
  insurancePolicies: Array<IHighwayInsurancePolicy>
  isMonitored: Scalars['Boolean']
  legalName: Scalars['String']
  mcNumber?: Maybe<Scalars['Int']>
  motorCarrierId: Scalars['ID']
  operatingStatus?: Maybe<Scalars['String']>
  rulesAssessmentPass: Scalars['Boolean']
  rulesAssessments: Array<IHighwayRulesAssessment>
  safetyRating?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
  vehicleOosInspections?: Maybe<Scalars['Int']>
  vehicles: IHighwayVehicleConnection
}

export type IHighwayCarrierVehiclesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  type?: Maybe<IHighwayVehicleTypes>
}

export type IHighwayContact = {
  __typename?: 'HighwayContact'
  createdAt: Scalars['ISO8601DateTime']
  emailAddress?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  isType?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type IHighwayInsuranceCertificate = {
  __typename?: 'HighwayInsuranceCertificate'
  contentType?: Maybe<Scalars['String']>
  createdAt: Scalars['ISO8601DateTime']
  filename?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  signedUrl?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
  url?: Maybe<Scalars['String']>
}

export type IHighwayInsurancePolicy = {
  __typename?: 'HighwayInsurancePolicy'
  actualCashValue?: Maybe<Scalars['Boolean']>
  anyAuto?: Maybe<Scalars['Boolean']>
  cancellationDate?: Maybe<Scalars['ISO8601Date']>
  coverageLimit?: Maybe<Scalars['String']>
  createdAt: Scalars['ISO8601DateTime']
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  effectiveDate?: Maybe<Scalars['ISO8601Date']>
  expirationDate?: Maybe<Scalars['ISO8601Date']>
  hiredAutos?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['ID']>
  insuranceCertificate?: Maybe<IHighwayInsuranceCertificate>
  insurer?: Maybe<IHighwayInsurer>
  isRefrigerationBreakdownIncluded?: Maybe<Scalars['Boolean']>
  isType?: Maybe<Scalars['String']>
  nonOwnedAutos?: Maybe<Scalars['Boolean']>
  ownedAutos?: Maybe<Scalars['Boolean']>
  policyNumber?: Maybe<Scalars['String']>
  scheduledAutos?: Maybe<Scalars['Boolean']>
  status?: Maybe<Scalars['String']>
  statutoryLimits?: Maybe<Scalars['Boolean']>
  transfixFlags?: Maybe<ITransfixHighwayInsurancePolicyFlag>
  updatedAt: Scalars['ISO8601DateTime']
}

export enum IHighwayInsurancePolicyTypes {
  automobile_liability = 'automobile_liability',
  commercial_general_liability = 'commercial_general_liability',
  contingent_auto = 'contingent_auto',
  contingent_cargo = 'contingent_cargo',
  motor_truck_cargo = 'motor_truck_cargo',
  trailer_interchange = 'trailer_interchange',
  workers_compensation = 'workers_compensation',
}

export type IHighwayInsurer = {
  __typename?: 'HighwayInsurer'
  city?: Maybe<Scalars['String']>
  createdAt: Scalars['ISO8601DateTime']
  id?: Maybe<Scalars['ID']>
  naic: Scalars['String']
  name?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  postalCode?: Maybe<Scalars['String']>
  shortName?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  street1?: Maybe<Scalars['String']>
  street2?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
  website?: Maybe<Scalars['String']>
}

export type IHighwayRulesAssessment = {
  __typename?: 'HighwayRulesAssessment'
  classificationName: Scalars['String']
  createdAt: Scalars['ISO8601DateTime']
  id?: Maybe<Scalars['ID']>
  override?: Maybe<IRulesAssessmentOverride>
  overrides: Scalars['JSON']
  result: Scalars['String']
  ruleName: Scalars['String']
  updatedAt: Scalars['ISO8601DateTime']
}

export type IHighwayVehicle = {
  __typename?: 'HighwayVehicle'
  cabType?: Maybe<Scalars['String']>
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  isType?: Maybe<Scalars['String']>
  licensePlateNumber?: Maybe<Scalars['String']>
  licensePlateState?: Maybe<Scalars['String']>
  make?: Maybe<Scalars['String']>
  model?: Maybe<Scalars['String']>
  modelYear?: Maybe<Scalars['Int']>
  powerUnitType?: Maybe<Scalars['String']>
  trailerType?: Maybe<Scalars['String']>
  updatedAt: Scalars['ISO8601DateTime']
  vin?: Maybe<Scalars['String']>
  weightClass?: Maybe<Scalars['String']>
}

/** The connection type for HighwayVehicle. */
export type IHighwayVehicleConnection = {
  __typename?: 'HighwayVehicleConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IHighwayVehicleEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IHighwayVehicle>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IHighwayVehicleEdge = {
  __typename?: 'HighwayVehicleEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IHighwayVehicle>
}

export enum IHighwayVehicleTypes {
  power_unit = 'power_unit',
  trailer = 'trailer',
}

export enum IIntelligentRecommendationsEventTypeEnum {
  click = 'click',
  view = 'view',
}

export type IJoinMotorCarrierInput = {
  dotNumber?: Maybe<Scalars['Int']>
  mcNumber?: Maybe<Scalars['Int']>
}

/** Autogenerated input type of JoinMotorCarriers */
export type IJoinMotorCarriersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  motorCarriers: Array<IJoinMotorCarrierInput>
}

/** Autogenerated return type of JoinMotorCarriers */
export type IJoinMotorCarriersPayload = {
  __typename?: 'JoinMotorCarriersPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  motorCarriers?: Maybe<Array<IMotorCarrier>>
}

export type ILocation = {
  __typename?: 'Location'
  address?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  contactEmail?: Maybe<Scalars['String']>
  contactName?: Maybe<Scalars['String']>
  contactPhone?: Maybe<Scalars['String']>
  contactPhoneExt?: Maybe<Scalars['String']>
  countryCode: ICountries
  countryName: Scalars['String']
  id: Scalars['ID']
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
  stateCode: Scalars['String']
  stateName: Scalars['String']
  timezone?: Maybe<Scalars['String']>
  zipcode?: Maybe<Scalars['String']>
}

export type ILocationInput = {
  address?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  contactEmail?: Maybe<Scalars['String']>
  contactName?: Maybe<Scalars['String']>
  contactPhone?: Maybe<Scalars['String']>
  contactPhoneExt?: Maybe<Scalars['String']>
  countryCode?: Maybe<Scalars['String']>
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
  stateCode?: Maybe<Scalars['String']>
  stateName?: Maybe<Scalars['String']>
  zipcode?: Maybe<Scalars['String']>
}

export type IMapboxFeature = {
  __typename?: 'MapboxFeature'
  boundingBox?: Maybe<Array<Scalars['Float']>>
  center?: Maybe<Array<Scalars['Float']>>
  context?: Maybe<Array<IMapboxFeatureContext>>
  geometry?: Maybe<IMapboxFeatureGeometry>
  id: Scalars['String']
  placeName?: Maybe<Scalars['String']>
  placeType?: Maybe<Array<Scalars['String']>>
  properties?: Maybe<IMapboxFeatureProperty>
  relevance?: Maybe<Scalars['Int']>
  text?: Maybe<Scalars['String']>
  type: Scalars['String']
}

export type IMapboxFeatureContext = {
  __typename?: 'MapboxFeatureContext'
  countryCode?: Maybe<Scalars['String']>
  countryName?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  wikidata?: Maybe<Scalars['String']>
}

export type IMapboxFeatureGeometry = {
  __typename?: 'MapboxFeatureGeometry'
  coordinates?: Maybe<Array<Scalars['Float']>>
  type?: Maybe<Scalars['String']>
}

export type IMapboxFeatureProperty = {
  __typename?: 'MapboxFeatureProperty'
  shortCode?: Maybe<Scalars['String']>
  wikidata?: Maybe<Scalars['String']>
}

export type IMarketplaceFacility = {
  __typename?: 'MarketplaceFacility'
  facilityType?: Maybe<IMarketplaceFacilityTypes>
  id: Scalars['ID']
  /** Facility location information */
  location: ILocation
  name: Scalars['String']
  uuid: Scalars['ID']
}

export enum IMarketplaceFacilityTypes {
  /** crossdock */
  crossdock = 'crossdock',
  /** retail */
  retail = 'retail',
  /** warehouse */
  warehouse = 'warehouse',
}

export type IMarketplaceGraphShipmentAccessorialComcheck = {
  __typename?: 'MarketplaceGraphShipmentAccessorialComcheck'
  amount: Scalars['Float']
  id: Scalars['ID']
}

export type IMarketplaceGraphShipmentStop = {
  __typename?: 'MarketplaceGraphShipmentStop'
  appointment: IMarketplaceGraphShipmentStopAppointment
  companyName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  stopSequence: Scalars['Int']
  stopType: IStop
}

export type IMarketplaceGraphShipmentStopAppointment = {
  __typename?: 'MarketplaceGraphShipmentStopAppointment'
  endAt?: Maybe<Scalars['ISO8601DateTime']>
  startAt?: Maybe<Scalars['ISO8601DateTime']>
  timezone: Scalars['String']
}

export type IMarketplaceShipment = {
  __typename?: 'MarketplaceShipment'
  id: Scalars['ID']
  marketplaceId: Scalars['ID']
}

export enum IMarketplaceShipmentStatus {
  Covered = 'Covered',
  Offered = 'Offered',
  Tendered = 'Tendered',
  WaterfallOffered = 'WaterfallOffered',
}

export type IMarketplaceStops = {
  __typename?: 'MarketplaceStops'
  address: IAddress
  appointmentNumber?: Maybe<Scalars['String']>
  bolNumber: Scalars['String']
  checkedInAt?: Maybe<Scalars['String']>
  checkedOutAt?: Maybe<Scalars['String']>
  clientName?: Maybe<Scalars['String']>
  commodity?: Maybe<Scalars['String']>
  displayTimezone?: Maybe<Scalars['String']>
  endAt?: Maybe<Scalars['String']>
  externalUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  instructionsFromCustomer?: Maybe<Scalars['String']>
  isDropTrailer: Scalars['Boolean']
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
  startAt?: Maybe<Scalars['String']>
  stopSequence?: Maybe<Scalars['Int']>
  stopType: IStop
  trailerArrivedAt?: Maybe<Scalars['ISO8601DateTime']>
  trailerEmptiedAt?: Maybe<Scalars['ISO8601DateTime']>
  unit?: Maybe<Scalars['String']>
  unitQuantity?: Maybe<Scalars['Float']>
  weight?: Maybe<Scalars['Float']>
}

export type IMissingInfoCounts = {
  __typename?: 'MissingInfoCounts'
  /**
   * Count of shipments without a POD, a rejected POD, or that are lacking a Lumper
   * receipt. These are only missing after delivery. Urgent 24hrs after delivery
   */
  missingDocuments: Scalars['Int']
  /** Count of shipments without driver assigned. It's urgent within 4 hours of pickup */
  missingDriver: Scalars['Int']
  /** Count of shipments without an ETA set. It's urgent within 1 hour of pickup */
  missingEta: Scalars['Int']
  /** Count of shipments without a trailer assigned. It's urgent within 4 hours of pickup */
  missingTrailer: Scalars['Int']
  /** Count of shipments without a truck assigned. It's urgent within 4 hours of pickup */
  missingTruck: Scalars['Int']
  /** Count of shipments without an assigned vin */
  missingVin: Scalars['Int']
  /** The total count of shipments missing driver, truck, or trailer assignations */
  totalMissingAssignments: Scalars['Int']
  /** The total count of shipments missing documents */
  totalMissingDocuments: Scalars['Int']
}

export type IMotorCarrier = {
  __typename?: 'MotorCarrier'
  /** The motor carrier's certification details. */
  certifications: Array<IMotorCarrierCertification>
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** The motor carrier doing business as (DBA) name. */
  dbaName?: Maybe<Scalars['String']>
  /** The motor carrier dedicated lane rate preferences. */
  dedicatedLaneRatePreference?: Maybe<IMotorCarrierDedicatedLaneRatePreference>
  /** The motor carrier department of Transportation (DOT) identification number. */
  dotNumber: Scalars['Int']
  /** The motor carrier's endorsement titles. */
  endorsements: Array<Scalars['String']>
  /** The motor carrier equipment capabilities. */
  equipmentCapability?: Maybe<IMotorCarrierEquipmentCapability>
  /** The motor carrier's excluded commodity titles. */
  excludedCommodities: Array<Scalars['String']>
  /** The motor carrier  freight capabilities. */
  freightCapability?: Maybe<IMotorCarrierFreightCapability>
  /** Whether the motor carrier passes the BCA compliance rule. */
  hasBca: Scalars['Boolean']
  /** Whether the motor carrier passes the insurance compliance rules. */
  hasInsurance: Scalars['Boolean']
  /** Whether the motor carrier passes the W9 compliance rule. */
  hasW9: Scalars['Boolean']
  highwayCarrier?: Maybe<IHighwayCarrier>
  /** The motor carrier table primary key identifier. */
  id: Scalars['ID']
  /** Whether the motor carrier has an established KeepTruckin (aka Motive) API connection. */
  isKeepTruckinEnabled: Scalars['Boolean']
  /** The motor carrier team member join requests. */
  joinRequests: Array<IMotorCarrierJoinRequest>
  /** The motor carrier legal name. */
  legalName?: Maybe<Scalars['String']>
  /** The motor carrier  ;loading capabilities. */
  loadingCapability?: Maybe<IMotorCarrierLoadingCapability>
  /** The Motor Carrier (MC) identification number. */
  mcNumber?: Maybe<Scalars['Int']>
  /** The motor carrier display name. */
  name?: Maybe<Scalars['String']>
  /** The motor carrier rate type preferences. */
  rateTypePreference?: Maybe<IMotorCarrierRateTypePreference>
  /** The number of saved_searches associated with the motor carrier. */
  savedSearchCount: Scalars['Int']
  /** The motor carrier SmartWay registration details. */
  smartWayRegistration?: Maybe<IMotorCarrierSmartWayRegistration>
  /** The associated marketplace carrier application state. */
  state?: Maybe<ICarrierApplicationStates>
  /** The number of team members associated with the motor carrier. */
  teamMemberCount: Scalars['Int']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  /** A subquery for associated motor carrier user records. */
  users: IMotorCarrierUserConnection
}

export type IMotorCarrierUsersArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  role?: Maybe<Array<IUserRoleEnum>>
  type?: Maybe<Array<IUserTypeEnum>>
}

export type IMotorCarrierCertification = {
  __typename?: 'MotorCarrierCertification'
  /** The certifications table foreign key identifier. */
  certificationId: Scalars['ID']
  /** The certification code. */
  code: ICertificationCode
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** The motor carrier certifications table primary key identifier. */
  id: Scalars['ID']
  /** Whether the certification has been verified by supplier.io or independently by transfix. */
  isVerified: Scalars['Boolean']
  /** The organization that issued the certification. */
  issuingOrganization?: Maybe<Scalars['String']>
  /** The motor carriers table foreign key identifier. */
  motorCarrierId: Scalars['ID']
  /** The date the certification expires. */
  renewalDate?: Maybe<Scalars['ISO8601Date']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IMotorCarrierComplianceFlag = {
  __typename?: 'MotorCarrierComplianceFlag'
  complianceFlag: IComplianceFlag
  deprecatedAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  motorCarrier: IMotorCarrier
}

export type IMotorCarrierDedicatedLaneRatePreference = {
  __typename?: 'MotorCarrierDedicatedLaneRatePreference'
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  isInterestedInDedicatedLanes: Scalars['Boolean']
  minimumRatePerMile?: Maybe<Scalars['Float']>
  updatedAt: Scalars['ISO8601DateTime']
}

export enum IMotorCarrierEntityTypesEnum {
  /** C Corporation */
  ccorp = 'ccorp',
  /** Individual/sole proprietor or single member LLC */
  individual = 'individual',
  /** Limited Liability Company */
  llc = 'llc',
  /** Partnership */
  partnership = 'partnership',
  /** S Corporation */
  scorp = 'scorp',
  /** Trust/Estate */
  trust = 'trust',
}

export type IMotorCarrierEquipmentCapability = {
  __typename?: 'MotorCarrierEquipmentCapability'
  /** Date the request was created */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  /** Carrier capable of handling dry van freight */
  isDryVanCapable: Scalars['Boolean']
  /** Carrier capable of handling flatbed freight */
  isFlatbedCapable: Scalars['Boolean']
  /** Carrier capable of handling reefer freight */
  isReeferCapable: Scalars['Boolean']
  /** Carrier only has trailers, no power units */
  isTrailerOnly: Scalars['Boolean']
  /** The carrier the request is for */
  motorCarrier: IMotorCarrier
  /** Number of power units the carrier has */
  powerUnitCount: Scalars['Int']
  /** Number of trailers the carrier has */
  trailerCount: Scalars['Int']
  /** Date the request was last updated */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IMotorCarrierFreightCapability = {
  __typename?: 'MotorCarrierFreightCapability'
  /** Date the request was created */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  /** Carrier capable of picking up drayage freight, e.g. shipping containers from ocean ports */
  isDrayageCapable: Scalars['Boolean']
  /** Carrier capable of handling full truckloads */
  isFtlCapable: Scalars['Boolean']
  /** Carrier capable of handling intermodal freight */
  isIntermodalCapable: Scalars['Boolean']
  /** Carrier capable of handling less than truckloads */
  isLtlCapable: Scalars['Boolean']
  /** The carrier the request is for */
  motorCarrier: IMotorCarrier
  /** Date the request was last updated */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IMotorCarrierInsuranceContact = {
  __typename?: 'MotorCarrierInsuranceContact'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** DeletedAt timestamp in UTC */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  /** Contact email of the insurance agent */
  email: Scalars['String']
  /** Full name of the insurance agent */
  fullName: Scalars['String']
  /** The motor carrier insurance contacts table primary key identifier. */
  id: Scalars['ID']
  insuranceDocuments?: Maybe<Array<Scalars['JSON']>>
  /** The motor carriers table foreign key identifier. */
  motorCarrierId: Scalars['ID']
  /** Name of the insurance organizations/company */
  organizationName: Scalars['String']
  /** Contact phone number of the insurance agent */
  phoneNumber: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IMotorCarrierInsuranceContactInput = {
  email: Scalars['String']
  fullName: Scalars['String']
  insuranceDocuments?: Maybe<Array<IAttachableFileInput>>
  motorCarrierId: Scalars['ID']
  organizationName: Scalars['String']
  phoneNumber: Scalars['String']
}

export type IMotorCarrierJoinRequest = {
  __typename?: 'MotorCarrierJoinRequest'
  /** Date the request was approved */
  approvedAt?: Maybe<Scalars['ISO8601DateTime']>
  /** ID of for the transfix user approving the request */
  approvedByTransfixUserId?: Maybe<Scalars['ID']>
  /** Date the request was created */
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  /** The carrier the request is for */
  motorCarrier: IMotorCarrier
  /** ID of for the transfix user requesting to join the carrier */
  requestedByTransfixUserId: Scalars['ID']
  /** Date the request was last updated */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IMotorCarrierLoadingCapability = {
  __typename?: 'MotorCarrierLoadingCapability'
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  isDropCapable: Scalars['Boolean']
  isHeavyLoadCapable: Scalars['Boolean']
  isLiveCapable: Scalars['Boolean']
  isPowerOnly: Scalars['Boolean']
  updatedAt: Scalars['ISO8601DateTime']
}

export type IMotorCarrierRateTypePreference = {
  __typename?: 'MotorCarrierRateTypePreference'
  allowsAllIn: Scalars['Boolean']
  allowsDayRate: Scalars['Boolean']
  createdAt: Scalars['ISO8601DateTime']
  hasLineHaulFuelSurcharge: Scalars['Boolean']
  id: Scalars['ID']
  updatedAt: Scalars['ISO8601DateTime']
}

export type IMotorCarrierSmartWayRegistration = {
  __typename?: 'MotorCarrierSmartWayRegistration'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** The motor_carrier_smart_way_registration PK id */
  id: Scalars['ID']
  /** Whether the motor carrier is registered with SmartWay */
  isRegistered: Scalars['Boolean']
  /** The carrier the request is for */
  motorCarrier: IMotorCarrier
  /** The date the motor carrier's SmartWay registration expires. */
  renewalDate?: Maybe<Scalars['ISO8601Date']>
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IMotorCarrierTransfixRule = {
  __typename?: 'MotorCarrierTransfixRule'
  /** Primary key identifier */
  id: Scalars['ID']
  /** Key reference from source */
  key: Scalars['String']
  /** Name of the rule */
  name: Scalars['String']
}

export type IMotorCarrierTransfixRulesAssessment = {
  __typename?: 'MotorCarrierTransfixRulesAssessment'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  /** Primary key identifier */
  id: Scalars['ID']
  /** Motor carrier associated with the assessment */
  motorCarrier: IMotorCarrier
  /** Any overrides present for this relationship */
  override?: Maybe<IRulesAssessmentOverride>
  /** The result of the rule evaluation */
  result: Scalars['String']
  /** Motor carrier transfix rule associated with this record */
  rule: IMotorCarrierTransfixRule
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

export type IMotorCarrierUser = {
  __typename?: 'MotorCarrierUser'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  dispatcher?: Maybe<IDispatcher>
  driver?: Maybe<IDriver>
  id: Scalars['ID']
  motorCarrier: IMotorCarrier
  role: IUserRoleEnum
  type: IUserTypeEnum
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** The connection type for MotorCarrierUser. */
export type IMotorCarrierUserConnection = {
  __typename?: 'MotorCarrierUserConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IMotorCarrierUserEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IMotorCarrierUser>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IMotorCarrierUserEdge = {
  __typename?: 'MotorCarrierUserEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IMotorCarrierUser>
}

export type IMutation = {
  __typename?: 'Mutation'
  /** create a shipment accessorial document */
  createAccessorialDocument?: Maybe<ICreateAccessorialDocumentPayload>
  /** Creates a new dispatcher */
  createDispatcher?: Maybe<ICreateDispatcherPayload>
  /** Creates a new driver */
  createDriver?: Maybe<ICreateDriverPayload>
  /** create a lumper shipment accessorial */
  createLumperRelayPayments?: Maybe<ICreateLumperRelayPaymentsPayload>
  /** Create a Motor Carrier by providing an MC or DOT number. */
  createMotorCarrier?: Maybe<ICreateMotorCarrierPayload>
  createMotorCarrierBca?: Maybe<ICreateMotorCarrierBcaPayload>
  createMotorCarrierComplianceFlag?: Maybe<ICreateMotorCarrierComplianceFlagPayload>
  createMotorCarrierInsuranceContacts?: Maybe<ICreateMotorCarrierInsuranceContactsPayload>
  /** Creates a new owner operator */
  createOwnerOperator?: Maybe<ICreateOwnerOperatorPayload>
  createRulesAssessmentOverrides?: Maybe<ICreateRulesAssessmentOverridesPayload>
  createSafetyLetter?: Maybe<ICreateSafetyLetterPayload>
  /** Creates a new saved search */
  createSavedSearch?: Maybe<ICreateSavedSearchPayload>
  createTrailer?: Maybe<ICreateTrailerPayload>
  /** Creates a new truck */
  createTruck?: Maybe<ICreateTruckPayload>
  /** Creates new truck locations in marketplace */
  createTruckLocations?: Maybe<ICreateTruckLocationsPayload>
  /** Deactivate relay payments code */
  deactivateRelayPayment?: Maybe<IDeactivateRelayPaymentPayload>
  declineShipment?: Maybe<IDeclineShipmentPayload>
  deleteMotorCarrierCertification?: Maybe<IDeleteMotorCarrierCertificationPayload>
  /** Deletes a saved search subscriber */
  deleteSavedSearchSubscriber?: Maybe<IDeleteSavedSearchSubscriberPayload>
  /** Delete's a user's motor carrier users in FP and parent and child users in transfix */
  deleteUserAccount?: Maybe<IDeleteUserAccountPayload>
  dispatchShipment?: Maybe<IDispatchShipmentPayload>
  guidedBid?: Maybe<IGuidedBidPayload>
  /** Join or request to join the listed motor carriers. */
  joinMotorCarriers?: Maybe<IJoinMotorCarriersPayload>
  refreshHighwayData?: Maybe<IRefreshHighwayDataPayload>
  /** Requests detention */
  requestDetention?: Maybe<IRequestDetentionPayload>
  /** Sends event to Snowflake about user engagement with Intelligent Recs */
  sendIntelligentRecommendationsEvent?: Maybe<ISendIntelligentRecommendationsEventPayload>
  syncHighwayDataIntoMotorCarrier?: Maybe<ISyncHighwayDataIntoMotorCarrierPayload>
  /** Updates the driver SMS status updates enabled settings */
  updateDriverSmsSettings?: Maybe<IUpdateDriverSmsSettingsPayload>
  updateMotorCarrierCertification?: Maybe<IUpdateMotorCarrierCertificationPayload>
  updateMotorCarrierCompanyInformation?: Maybe<IUpdateMotorCarrierCompanyInformationPayload>
  updateMotorCarrierDedicatedLaneRatePreference?: Maybe<
    IUpdateMotorCarrierDedicatedLaneRatePreferencePayload
  >
  updateMotorCarrierEndorsements?: Maybe<IUpdateMotorCarrierEndorsementsPayload>
  updateMotorCarrierEquipmentCapability?: Maybe<IUpdateMotorCarrierEquipmentCapabilityPayload>
  updateMotorCarrierExcludedCommodities?: Maybe<IUpdateMotorCarrierExcludedCommoditiesPayload>
  updateMotorCarrierFreightCapability?: Maybe<IUpdateMotorCarrierFreightCapabilityPayload>
  updateMotorCarrierLoadingCapability?: Maybe<IUpdateMotorCarrierLoadingCapabilityPayload>
  updateMotorCarrierRateTypePreference?: Maybe<IUpdateMotorCarrierRateTypePreferencePayload>
  updateMotorCarrierSmartWayRegistration?: Maybe<IUpdateMotorCarrierSmartWayRegistrationPayload>
  updateMotorCarrierTransfixRulesAssessments?: Maybe<
    IUpdateMotorCarrierTransfixRulesAssessmentsPayload
  >
  /** Updates an existing saved search */
  updateSavedSearch?: Maybe<IUpdateSavedSearchPayload>
  updateTrailer?: Maybe<IUpdateTrailerPayload>
  updateTransfixHighwayInsurancePolicyFlag?: Maybe<IUpdateTransfixHighwayInsurancePolicyFlagPayload>
  uploadW9Form?: Maybe<IUploadW9FormPayload>
  /** Verify user by validating password or phone */
  verifyUserAccount?: Maybe<IVerifyUserAccountPayload>
}

export type IMutationCreateAccessorialDocumentArgs = {
  input: ICreateAccessorialDocumentInput
}

export type IMutationCreateDispatcherArgs = {
  input: ICreateDispatcherInput
}

export type IMutationCreateDriverArgs = {
  input: ICreateDriverInput
}

export type IMutationCreateLumperRelayPaymentsArgs = {
  input: ICreateLumperRelayPaymentsInput
}

export type IMutationCreateMotorCarrierArgs = {
  input: ICreateMotorCarrierInput
}

export type IMutationCreateMotorCarrierBcaArgs = {
  input: ICreateMotorCarrierBcaInput
}

export type IMutationCreateMotorCarrierComplianceFlagArgs = {
  input: ICreateMotorCarrierComplianceFlagInput
}

export type IMutationCreateMotorCarrierInsuranceContactsArgs = {
  input: ICreateMotorCarrierInsuranceContactsInput
}

export type IMutationCreateOwnerOperatorArgs = {
  input: ICreateOwnerOperatorInput
}

export type IMutationCreateRulesAssessmentOverridesArgs = {
  input: ICreateRulesAssessmentOverridesInput
}

export type IMutationCreateSafetyLetterArgs = {
  input: ICreateSafetyLetterInput
}

export type IMutationCreateSavedSearchArgs = {
  input: ICreateSavedSearchInput
}

export type IMutationCreateTrailerArgs = {
  input: ICreateTrailerInput
}

export type IMutationCreateTruckArgs = {
  input: ICreateTruckInput
}

export type IMutationCreateTruckLocationsArgs = {
  input: ICreateTruckLocationsInput
}

export type IMutationDeactivateRelayPaymentArgs = {
  input: IDeactivateRelayPaymentInput
}

export type IMutationDeclineShipmentArgs = {
  input: IDeclineShipmentInput
}

export type IMutationDeleteMotorCarrierCertificationArgs = {
  input: IDeleteMotorCarrierCertificationInput
}

export type IMutationDeleteSavedSearchSubscriberArgs = {
  input: IDeleteSavedSearchSubscriberInput
}

export type IMutationDeleteUserAccountArgs = {
  input: IDeleteUserAccountInput
}

export type IMutationDispatchShipmentArgs = {
  input: IDispatchShipmentInput
}

export type IMutationGuidedBidArgs = {
  input: IGuidedBidInput
}

export type IMutationJoinMotorCarriersArgs = {
  input: IJoinMotorCarriersInput
}

export type IMutationRefreshHighwayDataArgs = {
  input: IRefreshHighwayDataInput
}

export type IMutationRequestDetentionArgs = {
  input: IRequestDetentionInput
}

export type IMutationSendIntelligentRecommendationsEventArgs = {
  input: ISendIntelligentRecommendationsEventInput
}

export type IMutationSyncHighwayDataIntoMotorCarrierArgs = {
  input: ISyncHighwayDataIntoMotorCarrierInput
}

export type IMutationUpdateDriverSmsSettingsArgs = {
  input: IUpdateDriverSmsSettingsInput
}

export type IMutationUpdateMotorCarrierCertificationArgs = {
  input: IUpdateMotorCarrierCertificationInput
}

export type IMutationUpdateMotorCarrierCompanyInformationArgs = {
  input: IUpdateMotorCarrierCompanyInformationInput
}

export type IMutationUpdateMotorCarrierDedicatedLaneRatePreferenceArgs = {
  input: IUpdateMotorCarrierDedicatedLaneRatePreferenceInput
}

export type IMutationUpdateMotorCarrierEndorsementsArgs = {
  input: IUpdateMotorCarrierEndorsementsInput
}

export type IMutationUpdateMotorCarrierEquipmentCapabilityArgs = {
  input: IUpdateMotorCarrierEquipmentCapabilityInput
}

export type IMutationUpdateMotorCarrierExcludedCommoditiesArgs = {
  input: IUpdateMotorCarrierExcludedCommoditiesInput
}

export type IMutationUpdateMotorCarrierFreightCapabilityArgs = {
  input: IUpdateMotorCarrierFreightCapabilityInput
}

export type IMutationUpdateMotorCarrierLoadingCapabilityArgs = {
  input: IUpdateMotorCarrierLoadingCapabilityInput
}

export type IMutationUpdateMotorCarrierRateTypePreferenceArgs = {
  input: IUpdateMotorCarrierRateTypePreferenceInput
}

export type IMutationUpdateMotorCarrierSmartWayRegistrationArgs = {
  input: IUpdateMotorCarrierSmartWayRegistrationInput
}

export type IMutationUpdateMotorCarrierTransfixRulesAssessmentsArgs = {
  input: IUpdateMotorCarrierTransfixRulesAssessmentsInput
}

export type IMutationUpdateSavedSearchArgs = {
  input: IUpdateSavedSearchInput
}

export type IMutationUpdateTrailerArgs = {
  input: IUpdateTrailerInput
}

export type IMutationUpdateTransfixHighwayInsurancePolicyFlagArgs = {
  input: IUpdateTransfixHighwayInsurancePolicyFlagInput
}

export type IMutationUploadW9FormArgs = {
  input: IUploadW9FormInput
}

export type IMutationVerifyUserAccountArgs = {
  input: IVerifyUserAccountInput
}

export type IMyLoadsScreenFilter = {
  __typename?: 'MyLoadsScreenFilter'
  customers?: Maybe<Array<ICustomer>>
  dispatchers?: Maybe<Array<IDispatcher>>
  drivers?: Maybe<Array<IDriver>>
  motorCarriers: Array<IMotorCarrier>
}

export type IOfferedShipment = {
  __typename?: 'OfferedShipment'
  acceptedBidExpiredAt?: Maybe<Scalars['Float']>
  /** Calculated distance from the user's coordinates to the first pickup */
  calculatedDistance: Scalars['Float']
  carrierName: Scalars['String']
  carrierRate?: Maybe<Scalars['String']>
  carrierTotalRate?: Maybe<Scalars['String']>
  /** Driving distance from the user's coordinates to the first pickup */
  drivingDistance: Scalars['Float']
  /** Due to Apollo Client idiosyncracies, it needs an id field. This mirrors the marketplace_id value */
  id: Scalars['ID']
  /** Linear distance from the user's coordinates to the first pickup */
  linearDistance: Scalars['Float']
  marketplaceId: Scalars['ID']
  offerExpiresAt?: Maybe<Scalars['ISO8601DateTime']>
  offerType: IOfferedShipmentOfferTypeEnum
  offeredState: IShipmentOfferState
  state: IMarketplaceShipmentStatus
  stops: Array<IMarketplaceStops>
  waterfallTimeLeftMinutes?: Maybe<Scalars['Float']>
}

/** The connection type for OfferedShipment. */
export type IOfferedShipmentConnection = {
  __typename?: 'OfferedShipmentConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IOfferedShipmentEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IOfferedShipment>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IOfferedShipmentEdge = {
  __typename?: 'OfferedShipmentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IOfferedShipment>
}

/** The different offers associated to the current user */
export enum IOfferedShipmentFilter {
  /** all */
  all = 'all',
  /** current */
  current = 'current',
  /** past */
  past = 'past',
}

export enum IOfferedShipmentOfferTypeEnum {
  BidAccepted = 'BidAccepted',
  ManualOffer = 'ManualOffer',
  WaterfallOffered = 'WaterfallOffered',
}

export enum IOfferedShipmentSorts {
  offer_expires_at = 'offer_expires_at',
}

/** Basic Motor Carrier info needed for onboarding. */
export type IOnboardingMotorCarrier = {
  __typename?: 'OnboardingMotorCarrier'
  addresses?: Maybe<Array<IHighwayAddress>>
  contacts?: Maybe<Array<IHighwayContact>>
  continuousAuthorityGrantDate?: Maybe<Scalars['ISO8601Date']>
  dbaName?: Maybe<Scalars['String']>
  dotNumber: Scalars['Int']
  ein?: Maybe<Scalars['String']>
  highwayId?: Maybe<Scalars['ID']>
  /** ID will be null if motor carrier does not exist in Transfix's system. */
  id?: Maybe<Scalars['ID']>
  insurancePolicies?: Maybe<Array<IHighwayInsurancePolicy>>
  legalName: Scalars['String']
  mcNumber?: Maybe<Scalars['Int']>
  rulesAssessmentPass?: Maybe<Scalars['Boolean']>
  rulesAssessments?: Maybe<Array<IHighwayRulesAssessment>>
  safetyRating?: Maybe<Scalars['String']>
  users: IMotorCarrierUserConnection
}

/** Basic Motor Carrier info needed for onboarding. */
export type IOnboardingMotorCarrierUsersArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  role?: Maybe<Array<IUserRoleEnum>>
  type?: Maybe<Array<IUserTypeEnum>>
}

export type IOwnerOperator = {
  __typename?: 'OwnerOperator'
  cellPhone: Scalars['String']
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  dispatcherId: Scalars['ID']
  driverId: Scalars['ID']
  email: Scalars['String']
  firstName: Scalars['String']
  id: Scalars['ID']
  lastName: Scalars['String']
  marketplaceId: Scalars['ID']
  motorCarrierId: Scalars['ID']
  phone: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
}

/** Information about pagination in a connection. */
export type IPageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>
}

export enum IPurposeCustomer {
  /** CUSTOMER_ADDITIONAL */
  customer_additional = 'customer_additional',
  /** CUSTOMER_PRIMARY */
  customer_primary = 'customer_primary',
  /** FACILITY_ADDITIONAL */
  facility_additional = 'facility_additional',
  /** FACILITY_PRIMARY */
  facility_primary = 'facility_primary',
  /** SHIPMENT_CUSTOMER */
  shipment_customer = 'shipment_customer',
  /** SHIPMENT_OPS_REPRESENTATIVE */
  shipment_ops_representative = 'shipment_ops_representative',
  /** SHIPMENT_SUBSCRIBER */
  shipment_subscriber = 'shipment_subscriber',
  /** STOP_FACILITY */
  stop_facility = 'stop_facility',
}

export type IQuery = {
  __typename?: 'Query'
  /** All accessorials belonging to a shipment, or fetches specific ones when ids are provided */
  accessorials: Array<IShipmentAccessorial>
  /** Gets all activities for the given input parameters */
  activities: IActivityConnection
  /** Exact carrier with the matching id */
  carrierApplication?: Maybe<ICarrierApplication>
  /** Set of carriers with the matching ids */
  carrierApplications?: Maybe<Array<ICarrierApplication>>
  /** Set of carrier scores for a user */
  carrierApplicationsForUser?: Maybe<Array<ICarrierApplication>>
  /** Exact contact with matching id */
  contact?: Maybe<IContact>
  /** Set of contacts with matching ids */
  contacts: Array<IContact>
  /** Gets all incomplete shipments assigned to the current user */
  currentUserIncompleteShipments: IShipmentConnection
  /** Find a Motor Carrier for onboarding by providing an MC or DOT number. */
  findOnboardingMotorCarrier?: Maybe<IOnboardingMotorCarrier>
  geocodingSearch: Array<IGeocoding>
  getCalculatedMiles: Scalars['Int']
  /** Check if W9 form has been uploaded and reviewed */
  getComplianceChecklist?: Maybe<IComplianceChecklist>
  /** Gets tracking-related fields on the shipment that is current or up next for the user */
  getCurrentShipment?: Maybe<ICurrentShipment>
  /** High-level tracking information for a given shipment */
  getTrackingSummary?: Maybe<IShipmentTrackingSummary>
  /** Exact Highway Carrier matching motor carrier id */
  highwayCarrier?: Maybe<IHighwayCarrier>
  /** Highway Insurance Policies matching motor carrier id and policy type */
  highwayInsurancePolicy?: Maybe<Array<IHighwayInsurancePolicy>>
  /** Last 4 VIN matching Highway Vehicle VIN */
  highwayVehicle?: Maybe<IHighwayVehicle>
  /** Insurance agent contacts for the carrier */
  insuranceContacts: Array<IMotorCarrierInsuranceContact>
  /** checks if facility is in relay payments network */
  isFacilityInRelayPaymentsNetwork?: Maybe<Scalars['Boolean']>
  mapboxFeatures: Array<IMapboxFeature>
  marketRate?: Maybe<Scalars['Float']>
  /** Exact motor carrier matching id */
  motorCarrier?: Maybe<IMotorCarrier>
  /** Return all motor carrier compliance flags based on passed motor carrier id */
  motorCarrierComplianceFlags?: Maybe<Array<IMotorCarrierComplianceFlag>>
  /** Exact motor carrier join request matching id */
  motorCarrierJoinRequest?: Maybe<IMotorCarrierJoinRequest>
  /** Set of motor carrier join requests for a user */
  motorCarrierJoinRequestsForUser?: Maybe<Array<IMotorCarrierJoinRequest>>
  /** Return transfix rule assessments for a given motor carrier */
  motorCarrierTransfixRulesAssessments?: Maybe<Array<IMotorCarrierTransfixRulesAssessment>>
  /** Exact motor carrier user matching id */
  motorCarrierUser?: Maybe<IMotorCarrierUser>
  /** Set of motor carrier users for user */
  motorCarrierUsersForUser: Array<IMotorCarrierUser>
  /** Set of motor carriers for user */
  motorCarriersForUser: Array<IMotorCarrier>
  /** Get Information used for my loads screen filters */
  myLoadsFilterInfo: IMyLoadsScreenFilter
  offeredShipmentConnection?: Maybe<IOfferedShipmentConnection>
  /**
   * Gets offered shipments for the current user of all carriers where they have
   * have dispatcher or OO user types with the provided filter applied to the results.
   */
  offeredShipments?: Maybe<Array<IOfferedShipment>>
  /** given a shipment id and a relay payments code id, gets the details */
  relayPaymentDetails?: Maybe<IRelayPaymentDetails>
  /** Gets Saved Searches from DB. */
  savedSearches: ISavedSearchConnection
  /** Search trailers */
  searchTrailers: ITrailerConnection
  /**
   * Gets shipments for the current user of all carriers where they have have
   * dispatcher or OO user types with the provided filter applied to the results.
   */
  shipment: IShipment
  /** The recommended shipments for a user */
  shipmentRecommendations: IRecommendedShipments
  /**
   * Gets shipments for the current user of all carriers where they have have
   * dispatcher or OO user types with the provided filter applied to the results.
   */
  shipments: IShipmentConnection
  /** Gets all shipments that are missing some sort of info. Can filter by what type of missing info you want */
  shipmentsMissingInfo: IShipmentMissingInfoConnection
  /** Determine if the current user should be tracking now based on upcoming shipments */
  shouldTrackNow: IShouldTrackNow
  /** Get details for a specific trailer */
  trailer: ITrailer
  /** [INACTIVE] Fetches the facilities in MP to which a trailer can be assigned */
  trailerAssignmentFacilities?: Maybe<IShipperFacilityConnection>
  /** Gets all trailers */
  trailers: ITrailerConnection
}

export type IQueryAccessorialsArgs = {
  ids?: Maybe<Array<Scalars['ID']>>
  shipmentId: Scalars['ID']
}

export type IQueryActivitiesArgs = {
  activityTypes?: Maybe<Array<IActivityTypes>>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  shipmentExternalId?: Maybe<Scalars['ID']>
  shipmentId?: Maybe<Scalars['ID']>
  transfixDriverId?: Maybe<Scalars['ID']>
}

export type IQueryCarrierApplicationArgs = {
  id: Scalars['ID']
}

export type IQueryCarrierApplicationsArgs = {
  ids: Array<Scalars['ID']>
}

export type IQueryContactArgs = {
  id: Scalars['ID']
}

export type IQueryContactsArgs = {
  ids: Array<Scalars['ID']>
}

export type IQueryCurrentUserIncompleteShipmentsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type IQueryFindOnboardingMotorCarrierArgs = {
  dotNumber?: Maybe<Scalars['Int']>
  mcNumber?: Maybe<Scalars['Int']>
}

export type IQueryGeocodingSearchArgs = {
  countries?: Maybe<Array<IGeocodingAllowedCountryEnum>>
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
  resultTypes?: Maybe<Array<IGeocodingResultTypeEnum>>
  searchString?: Maybe<Scalars['String']>
}

export type IQueryGetCalculatedMilesArgs = {
  stops: Array<ILocationInput>
}

export type IQueryGetComplianceChecklistArgs = {
  motorCarrierId: Scalars['ID']
}

export type IQueryGetTrackingSummaryArgs = {
  shipmentId: Scalars['ID']
}

export type IQueryHighwayCarrierArgs = {
  motorCarrierId: Scalars['ID']
}

export type IQueryHighwayInsurancePolicyArgs = {
  motorCarrierId: Scalars['ID']
  policyType: IHighwayInsurancePolicyTypes
}

export type IQueryHighwayVehicleArgs = {
  motorCarrierId: Scalars['ID']
  vin: Scalars['String']
}

export type IQueryInsuranceContactsArgs = {
  motorCarrierId: Scalars['ID']
}

export type IQueryIsFacilityInRelayPaymentsNetworkArgs = {
  stopId: Scalars['ID']
}

export type IQueryMapboxFeaturesArgs = {
  searchString: Scalars['String']
}

export type IQueryMarketRateArgs = {
  deliveryCity: Scalars['String']
  deliveryStateCode: Scalars['String']
  equipmentKey: ITcmEquipmentKeyTypes
  pickupCity: Scalars['String']
  pickupStateCode: Scalars['String']
  shipperApplicationId?: Maybe<Scalars['ID']>
}

export type IQueryMotorCarrierArgs = {
  id: Scalars['ID']
}

export type IQueryMotorCarrierComplianceFlagsArgs = {
  motorCarrierId: Scalars['ID']
}

export type IQueryMotorCarrierJoinRequestArgs = {
  id: Scalars['ID']
}

export type IQueryMotorCarrierTransfixRulesAssessmentsArgs = {
  motorCarrierId: Scalars['ID']
}

export type IQueryMotorCarrierUserArgs = {
  id: Scalars['ID']
}

export type IQueryOfferedShipmentConnectionArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  filter: IOfferedShipmentFilter
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  sortBy?: Maybe<IOfferedShipmentSorts>
  userLatitude?: Maybe<Scalars['Float']>
  userLongitude?: Maybe<Scalars['Float']>
}

export type IQueryOfferedShipmentsArgs = {
  filter: IOfferedShipmentFilter
}

export type IQueryRelayPaymentDetailsArgs = {
  id: Scalars['ID']
  shipmentId: Scalars['ID']
}

export type IQuerySavedSearchesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  sourceTypes?: Maybe<Array<ISavedSearchSourceTypes>>
}

export type IQuerySearchTrailersArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  carrierId: Scalars['ID']
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  searchTerm: Scalars['String']
  sortBy?: Maybe<Scalars['String']>
  sortDirection?: Maybe<ISortOrderEnum>
  states?: Maybe<Array<Scalars['String']>>
}

export type IQueryShipmentArgs = {
  id: Scalars['ID']
}

export type IQueryShipmentsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  customerId?: Maybe<Scalars['String']>
  dispatcherId?: Maybe<Scalars['Int']>
  driverId?: Maybe<Scalars['Int']>
  dropoffDate?: Maybe<Scalars['String']>
  dropoffFacilityId?: Maybe<Scalars['Int']>
  dropoffLocality?: Maybe<Scalars['String']>
  dropoffSubdivisionCode?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  maxAge?: Maybe<Scalars['Int']>
  motorCarrierId?: Maybe<Scalars['Int']>
  onlyExternalLoad?: Maybe<Scalars['String']>
  pickupDate?: Maybe<Scalars['String']>
  pickupFacilityId?: Maybe<Scalars['Int']>
  pickupLocality?: Maybe<Scalars['String']>
  pickupSubdivisionCode?: Maybe<Scalars['String']>
  podStatus?: Maybe<Array<IShipmentPodStatus>>
  referenceNumber?: Maybe<Scalars['String']>
  shipmentSource?: Maybe<Array<IShipmentSourceTypeEnum>>
  status?: Maybe<Array<IShipmentStatus>>
}

export type IQueryShipmentsMissingInfoArgs = {
  activeLoads?: Maybe<Scalars['Boolean']>
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  filters?: Maybe<Array<IShipmentMissingInfo>>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

export type IQueryTrailerArgs = {
  trailerId?: Maybe<Scalars['ID']>
  trailerNumber?: Maybe<Scalars['String']>
}

export type IQueryTrailerAssignmentFacilitiesArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  motorCarrierId: Scalars['ID']
  searchTerm?: Maybe<Scalars['String']>
  stateCode?: Maybe<Scalars['String']>
}

export type IQueryTrailersArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  carrierIds?: Maybe<Array<Scalars['ID']>>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
  numbers?: Maybe<Array<Scalars['String']>>
  sortBy?: Maybe<Scalars['String']>
  sortDirection?: Maybe<ISortOrderEnum>
  states?: Maybe<Array<Scalars['String']>>
}

export type IRecommendedShipments = {
  __typename?: 'RecommendedShipments'
  shipments: IAuctionShipmentConnection
  source: IShipmentRecommendationsSourceEnum
}

export type IRecommendedShipmentsShipmentsArgs = {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

/** Autogenerated input type of RefreshHighwayData */
export type IRefreshHighwayDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  motorCarrierId: Scalars['ID']
}

/** Autogenerated return type of RefreshHighwayData */
export type IRefreshHighwayDataPayload = {
  __typename?: 'RefreshHighwayDataPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

/** a relay-network number */
export type IRelayCodeDetails = {
  __typename?: 'RelayCodeDetails'
  code?: Maybe<Scalars['String']>
}

/** The specific payment info, whether a digital card or a code */
export type IRelayPaymentDetails = IDigitalCardDetails | IRelayCodeDetails

export type IRelayPaymentsCode = {
  __typename?: 'RelayPaymentsCode'
  amountUsed?: Maybe<Scalars['Float']>
  codeStatus: ICodeStatuses
  codeType?: Maybe<ICodeTypes>
  constraintAmount: Scalars['Float']
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
}

/** Autogenerated input type of RequestDetention */
export type IRequestDetentionInput = {
  attachments: Array<IAttachmentInput>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  durationMinutes: Scalars['Float']
  endAt: Scalars['String']
  shipmentId: Scalars['Int']
  source: IAccessorialSourceInputEnum
  startAt: Scalars['String']
  stopId: Scalars['Int']
}

/** Autogenerated return type of RequestDetention */
export type IRequestDetentionPayload = {
  __typename?: 'RequestDetentionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors?: Maybe<Array<IError>>
  success?: Maybe<Scalars['Boolean']>
}

export type IRulesAssessmentOverride = {
  __typename?: 'RulesAssessmentOverride'
  deprecatedAt?: Maybe<Scalars['ISO8601DateTime']>
  id: Scalars['ID']
  result: IRulesAssessmentOverrideResultEnum
  ruleName: Scalars['String']
  rulesAssessmentId: Scalars['ID']
  rulesAssessmentType: IRulesAssessmentOverrideTypeEnum
}

export enum IRulesAssessmentOverrideResultEnum {
  /** fail rule */
  fail = 'fail',
  /** pass rule */
  pass = 'pass',
}

export enum IRulesAssessmentOverrideTypeEnum {
  /** Highway rule */
  HighwayRulesAssessment = 'HighwayRulesAssessment',
  /** Transfix rule */
  MotorCarrierTransfixRulesAssessment = 'MotorCarrierTransfixRulesAssessment',
}

export type ISavedSearch = {
  __typename?: 'SavedSearch'
  createdAt?: Maybe<Scalars['ISO8601DateTime']>
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>
  deliveryCity?: Maybe<Scalars['String']>
  deliveryEndDate?: Maybe<Scalars['ISO8601Date']>
  deliveryLatitude?: Maybe<Scalars['Float']>
  deliveryLongitude?: Maybe<Scalars['Float']>
  deliveryMiles?: Maybe<Scalars['Float']>
  deliveryStartDate?: Maybe<Scalars['ISO8601Date']>
  deliveryStateCode?: Maybe<Scalars['String']>
  dropTrailer?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  loadedMilesMax?: Maybe<Scalars['Float']>
  loadedMilesMin?: Maybe<Scalars['Float']>
  motorCarrier?: Maybe<IMotorCarrier>
  motorCarrierId?: Maybe<Scalars['ID']>
  pickupCity?: Maybe<Scalars['String']>
  pickupEndDate?: Maybe<Scalars['ISO8601Date']>
  pickupIsoDaysOfWeek?: Maybe<Array<Scalars['Int']>>
  pickupLatitude?: Maybe<Scalars['Float']>
  pickupLongitude?: Maybe<Scalars['Float']>
  pickupMiles?: Maybe<Scalars['Float']>
  pickupStartDate?: Maybe<Scalars['ISO8601Date']>
  pickupStateCode?: Maybe<Scalars['String']>
  rate?: Maybe<Scalars['Float']>
  rateType?: Maybe<ISavedSearchRateTypes>
  sourceType?: Maybe<ISavedSearchSourceTypes>
  trailerType?: Maybe<IEquipmentTypes>
  transfixUserId: Scalars['ID']
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>
}

/** The connection type for SavedSearch. */
export type ISavedSearchConnection = {
  __typename?: 'SavedSearchConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ISavedSearchEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ISavedSearch>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  subscriberInfo: Scalars['JSON']
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type ISavedSearchEdge = {
  __typename?: 'SavedSearchEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<ISavedSearch>
}

export enum ISavedSearchRateTypes {
  all_in = 'all_in',
  rpm = 'rpm',
}

export enum ISavedSearchSourceTypes {
  auto_historical = 'auto_historical',
  cm_created = 'cm_created',
  dispatcher_created = 'dispatcher_created',
  dispatcher_truck_availability = 'dispatcher_truck_availability',
}

/** Autogenerated input type of SendIntelligentRecommendationsEvent */
export type ISendIntelligentRecommendationsEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  intelligentRecsEventType: IIntelligentRecommendationsEventTypeEnum
  shipmentIds: Array<Scalars['Int']>
  shipmentOrder: Array<Scalars['Int']>
}

/** Autogenerated return type of SendIntelligentRecommendationsEvent */
export type ISendIntelligentRecommendationsEventPayload = {
  __typename?: 'SendIntelligentRecommendationsEventPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors?: Maybe<Array<IError>>
  success: Scalars['Boolean']
}

export type IShipment = {
  __typename?: 'Shipment'
  characteristics?: Maybe<IShipmentCharacteristics>
  currentStopSequence?: Maybe<Scalars['Int']>
  customer?: Maybe<ICustomer>
  customerContact?: Maybe<ICustomerContact>
  customerNotes?: Maybe<Scalars['String']>
  dispatcherId?: Maybe<Scalars['ID']>
  drivers?: Maybe<Array<IDriver>>
  etaObject?: Maybe<IEtaObject>
  externalId?: Maybe<Scalars['ID']>
  firstPickupStartAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  isExternal: Scalars['Boolean']
  lastDropoffStartAt: Scalars['ISO8601DateTime']
  marketplaceId?: Maybe<Scalars['ID']>
  missingInfo?: Maybe<Array<IShipmentMissingInfo>>
  missingInfoUrgencyMessage?: Maybe<Scalars['String']>
  motorCarrier: IMotorCarrier
  motorCarrierId: Scalars['ID']
  mpPodState?: Maybe<Scalars['String']>
  podState: Scalars['String']
  podUploaded: Scalars['Boolean']
  status: Scalars['String']
  stops: Array<IStops>
  temperatureSetting?: Maybe<ITemperatureSetting>
  trackingSummary?: Maybe<IShipmentTrackingSummary>
  trailer?: Maybe<ITrailer>
  trailerType?: Maybe<IEquipmentTypes>
  truck?: Maybe<ITruck>
  vin?: Maybe<Scalars['String']>
}

export type IShipmentAccessorial = {
  __typename?: 'ShipmentAccessorial'
  additionalInfo?: Maybe<Scalars['JSON']>
  carrierAmount: Scalars['Float']
  carrierState: IShipmentAccessorialCarrierStates
  /** the comcheck for the accessorial */
  comcheck?: Maybe<IMarketplaceGraphShipmentAccessorialComcheck>
  /** the date this accessorial was created */
  createdAt: Scalars['ISO8601DateTime']
  file?: Maybe<IDownloadable>
  id: Scalars['ID']
  inactiveRelayPaymentsCodes?: Maybe<Array<IRelayPaymentsCode>>
  name: IShipmentAccessorialNames
  relayPaymentsCode?: Maybe<IRelayPaymentsCode>
  /** the stop this accessorial is created for */
  shipmentStop?: Maybe<IMarketplaceGraphShipmentStop>
  shipperApprovalState?: Maybe<Scalars['String']>
  shipperFacility?: Maybe<IAccessorialShipperFacility>
}

export enum IShipmentAccessorialCarrierStates {
  /** APPROVED */
  approved = 'approved',
  /** PENDING */
  pending = 'pending',
  /** REJECTED */
  rejected = 'rejected',
}

export enum IShipmentAccessorialNames {
  /** Bridge Toll */
  bridge_toll = 'bridge_toll',
  /** Circuity Fee */
  circuity_fee = 'circuity_fee',
  /** Cross Dock */
  cross_dock = 'cross_dock',
  /** Deadhead Mileage */
  deadhead_mileage = 'deadhead_mileage',
  /** Deduction Fee */
  deduction_fee = 'deduction_fee',
  /** Detention Fee */
  detention_fee = 'detention_fee',
  /** Driver Assist */
  driver_assist = 'driver_assist',
  /** Driver Loading/Unloading */
  driver_loading_unloading = 'driver_loading_unloading',
  /** Driver Not Tracking Fee */
  driver_not_tracking_fee = 'driver_not_tracking_fee',
  /** ES-Escort Service Fee */
  es_escort_service_fee = 'es_escort_service_fee',
  /** Escort Fee */
  escort_fee = 'escort_fee',
  /** Financial Reconciliation (For AR/AP Use Only) */
  financial_reconciliation__for_ar_ap_use_only_ = 'financial_reconciliation__for_ar_ap_use_only_',
  /** Flat Rate */
  flat_rate = 'flat_rate',
  /** Insurance Claims */
  insurance_claims = 'insurance_claims',
  /** Keep from Freezing */
  keep_from_freezing = 'keep_from_freezing',
  /** Late Fee */
  late_fee = 'late_fee',
  /** Layover Fee */
  layover_fee = 'layover_fee',
  /** Lumper Charge */
  lumper_charge = 'lumper_charge',
  /** Miscellaneous */
  miscellaneous = 'miscellaneous',
  /** OTP/OTD Late Fee */
  otp_otd_late_fee = 'otp_otd_late_fee',
  /** Out of Route Miles Fee */
  out_of_route_miles_fee = 'out_of_route_miles_fee',
  /** Preloading Charge */
  preloading_charge = 'preloading_charge',
  /** Reconsignment Fee */
  reconsignment_fee = 'reconsignment_fee',
  /** Redelivery / Refused Goods */
  redelivery___refused_goods = 'redelivery___refused_goods',
  /** Restack */
  restack = 'restack',
  /** Returned Load */
  returned_load = 'returned_load',
  /** Stop-off Charge */
  stop_off_charge = 'stop_off_charge',
  /** Storage Fee */
  storage_fee = 'storage_fee',
  /** Team Driver */
  team_driver = 'team_driver',
  /** Tier 1 */
  tier_1 = 'tier_1',
  /** TONU */
  tonu = 'tonu',
  /** Trailer Detention Fee */
  trailer_detention_fee = 'trailer_detention_fee',
  /** Up Charge */
  up_charge = 'up_charge',
}

export type IShipmentCharacteristics = {
  __typename?: 'ShipmentCharacteristics'
  fraudValidation: Scalars['Boolean']
}

/** The connection type for Shipment. */
export type IShipmentConnection = {
  __typename?: 'ShipmentConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IShipmentEdge>>>
  /** Status JSON Format */
  groupedStatusCount: Array<Scalars['Int']>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IShipment>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  statusCount: Scalars['JSON']
  totalCount: Scalars['Int']
  trackingStatusCount: Scalars['JSON']
}

/** The connection type for Shipment. */
export type IShipmentConnectionGroupedStatusCountArgs = {
  customerId?: Maybe<Scalars['String']>
  dispatcherId?: Maybe<Scalars['Int']>
  driverId?: Maybe<Scalars['Int']>
  dropoffDate?: Maybe<Scalars['String']>
  dropoffFacilityId?: Maybe<Scalars['Int']>
  dropoffLocality?: Maybe<Scalars['String']>
  dropoffSubdivisionCode?: Maybe<Scalars['String']>
  groupedStatus: Array<IStatusCountInput>
  maxAge?: Maybe<Scalars['Int']>
  motorCarrierId?: Maybe<Scalars['Int']>
  onlyExternalLoad?: Maybe<Scalars['String']>
  pickupDate?: Maybe<Scalars['String']>
  pickupFacilityId?: Maybe<Scalars['Int']>
  pickupLocality?: Maybe<Scalars['String']>
  pickupSubdivisionCode?: Maybe<Scalars['String']>
  podStatus?: Maybe<Array<IShipmentPodStatus>>
  referenceNumber?: Maybe<Scalars['String']>
  shipmentSource?: Maybe<Array<IShipmentSourceTypeEnum>>
  status?: Maybe<Array<IShipmentStatus>>
}

export type IShipmentDriver = {
  __typename?: 'ShipmentDriver'
  id: Scalars['ID']
  shipmentId: Scalars['ID']
  smsStatusUpdatesEnabled: Scalars['Boolean']
}

/** An edge in a connection. */
export type IShipmentEdge = {
  __typename?: 'ShipmentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IShipment>
}

export enum IShipmentMissingInfo {
  /** DriverMissing */
  DriverMissing = 'DriverMissing',
  /** EtaMissing */
  EtaMissing = 'EtaMissing',
  /** LumperMissing */
  LumperMissing = 'LumperMissing',
  /** PodMissing */
  PodMissing = 'PodMissing',
  /** PodRejected */
  PodRejected = 'PodRejected',
  /** TrailerMissing */
  TrailerMissing = 'TrailerMissing',
  /** TruckMissing */
  TruckMissing = 'TruckMissing',
  /** VinMissing */
  VinMissing = 'VinMissing',
}

/** The connection type for Shipment. */
export type IShipmentMissingInfoConnection = {
  __typename?: 'ShipmentMissingInfoConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IShipmentMissingInfoEdge>>>
  itemizedCount: IMissingInfoCounts
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IShipment>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type IShipmentMissingInfoEdge = {
  __typename?: 'ShipmentMissingInfoEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IShipment>
}

export enum IShipmentOfferState {
  BidAccepted = 'BidAccepted',
  DedicatedRateCurrentTierCarrier = 'DedicatedRateCurrentTierCarrier',
  DedicatedRateOfferedToMoreCarriers = 'DedicatedRateOfferedToMoreCarriers',
  LoadUnavailable = 'LoadUnavailable',
  TransfixOffer = 'TransfixOffer',
}

export enum IShipmentPodStatus {
  /** POD_APPROVED */
  pod_approved = 'pod_approved',
  /** POD_IN_REVIEW */
  pod_in_review = 'pod_in_review',
  /** POD_PENDING */
  pod_pending = 'pod_pending',
  /** POD_REJECTED */
  pod_rejected = 'pod_rejected',
}

export enum IShipmentRecommendationsSourceEnum {
  /** Ds loads for you */
  ds_loads_for_you = 'ds_loads_for_you',
  /** Lane alert auto historical */
  lane_alert_auto_historical = 'lane_alert_auto_historical',
}

export enum IShipmentSourceTypeEnum {
  external = 'external',
  internal = 'internal',
}

export enum IShipmentStatus {
  /** AT_DROPOFF */
  at_dropoff = 'at_dropoff',
  /** AT_PICKUP */
  at_pickup = 'at_pickup',
  /** CANCELLED */
  cancelled = 'cancelled',
  /** CLAIM */
  claim = 'claim',
  /** COMPLETED */
  completed = 'completed',
  /** DELIVERED */
  delivered = 'delivered',
  /** DISPATCHED */
  dispatched = 'dispatched',
  /** IN_TRANSIT */
  in_transit = 'in_transit',
  /** IN_YARD */
  in_yard = 'in_yard',
  /** INVOICED */
  invoiced = 'invoiced',
  /** LOADING */
  loading = 'loading',
  /** PAYMENT_PENDING */
  payment_pending = 'payment_pending',
  /** PENDING */
  pending = 'pending',
  /** POD_REJECTED */
  pod_rejected = 'pod_rejected',
  /** READY_FOR_DISPATCH */
  ready_for_dispatch = 'ready_for_dispatch',
  /** TONU */
  tonu = 'tonu',
  /** UNLOADING */
  unloading = 'unloading',
}

export type IShipmentTrackingSummary = {
  __typename?: 'ShipmentTrackingSummary'
  isTracking: Scalars['Boolean']
  shouldBeTracking: Scalars['Boolean']
}

export type IShipperApplication = {
  __typename?: 'ShipperApplication'
  id: Scalars['ID']
  name: Scalars['String']
}

export type IShipperFacility = {
  __typename?: 'ShipperFacility'
  contacts: Array<IShipperFacilityContact>
  facility: IMarketplaceFacility
  id: Scalars['ID']
  note?: Maybe<Scalars['String']>
  shipperApplication: IShipperApplication
  shipperApplicationId: Scalars['ID']
  uuid: Scalars['ID']
}

/** The connection type for ShipperFacility. */
export type IShipperFacilityConnection = {
  __typename?: 'ShipperFacilityConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IShipperFacilityEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IShipperFacility>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

export type IShipperFacilityContact = {
  __typename?: 'ShipperFacilityContact'
  canScheduleFor?: Maybe<Scalars['String']>
  contactRoles?: Maybe<Array<Scalars['String']>>
  contactType: Scalars['String']
  email?: Maybe<Scalars['String']>
  facilityUuid?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  note?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  phoneExtension?: Maybe<Scalars['String']>
  shipperFacilityUuid?: Maybe<Scalars['ID']>
  website?: Maybe<Scalars['String']>
}

/** An edge in a connection. */
export type IShipperFacilityEdge = {
  __typename?: 'ShipperFacilityEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<IShipperFacility>
}

export type IShouldTrackNow = {
  __typename?: 'ShouldTrackNow'
  trackNow: Scalars['Boolean']
}

export enum ISortOrderEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type IStatusCountInput = {
  external?: Maybe<Array<Scalars['String']>>
  internal?: Maybe<Array<Scalars['String']>>
}

export enum IStop {
  dropoff = 'dropoff',
  pickup = 'pickup',
}

export type IStops = {
  __typename?: 'Stops'
  address: IAddress
  appointmentNumber?: Maybe<Scalars['String']>
  bolNumber: Scalars['String']
  checkedInAt?: Maybe<Scalars['ISO8601DateTime']>
  checkedOutAt?: Maybe<Scalars['ISO8601DateTime']>
  city: Scalars['String']
  countryCode: Scalars['String']
  displayTimezone?: Maybe<Scalars['String']>
  endAt?: Maybe<Scalars['ISO8601DateTime']>
  facility?: Maybe<ICustomer>
  facilityContact?: Maybe<ICustomerContact>
  id: Scalars['ID']
  instructions?: Maybe<Scalars['String']>
  isDropTrailer: Scalars['Boolean']
  marketplaceId?: Maybe<Scalars['ID']>
  referenceNumber: Scalars['String']
  relativeStopSequence?: Maybe<Scalars['Int']>
  shipmentId: Scalars['ID']
  startAt?: Maybe<Scalars['ISO8601DateTime']>
  stateCode: Scalars['String']
  stopSequence: Scalars['Int']
  stopType: IStop
}

/** Autogenerated input type of SyncHighwayDataIntoMotorCarrier */
export type ISyncHighwayDataIntoMotorCarrierInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  motorCarrierId: Scalars['ID']
  shouldSyncDbaName?: Maybe<Scalars['Boolean']>
  shouldSyncDotNumber?: Maybe<Scalars['Boolean']>
  shouldSyncLegalName?: Maybe<Scalars['Boolean']>
  shouldSyncMcNumber?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of SyncHighwayDataIntoMotorCarrier */
export type ISyncHighwayDataIntoMotorCarrierPayload = {
  __typename?: 'SyncHighwayDataIntoMotorCarrierPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  motorCarrier?: Maybe<IMotorCarrier>
}

export enum ITcmEquipmentKeyTypes {
  dry_van = 'dry_van',
  reefer = 'reefer',
}

export type ITemperatureSetting = {
  __typename?: 'TemperatureSetting'
  precool?: Maybe<Scalars['String']>
  temperatureType?: Maybe<Scalars['String']>
}

export type ITrailer = {
  __typename?: 'Trailer'
  arrivedAt?: Maybe<Scalars['ISO8601DateTime']>
  carrierName: Scalars['String']
  facility?: Maybe<ITrailerShipperFacility>
  id: Scalars['ID']
  length?: Maybe<Scalars['String']>
  note?: Maybe<Scalars['String']>
  number: Scalars['String']
  shipmentDetails?: Maybe<ITrailerShipmentDetails>
  state: Scalars['String']
  trailerType?: Maybe<Scalars['String']>
}

/** The connection type for Trailer. */
export type ITrailerConnection = {
  __typename?: 'TrailerConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ITrailerEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ITrailer>>>
  /** Information to aid in pagination. */
  pageInfo: IPageInfo
  /** Total number of items in this collection */
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type ITrailerEdge = {
  __typename?: 'TrailerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<ITrailer>
}

export type ITrailerShipmentDetails = {
  __typename?: 'TrailerShipmentDetails'
  deliveryArrivedAt?: Maybe<Scalars['String']>
  deliveryCity: Scalars['String']
  deliveryIsDrop: Scalars['Boolean']
  deliveryStateCode: Scalars['String']
  deliveryTimezone?: Maybe<Scalars['String']>
  deliveryTrailerArrivedAt?: Maybe<Scalars['String']>
  deliveryTrailerEmptiedAt?: Maybe<Scalars['String']>
  displayId: Scalars['String']
  id: Scalars['ID']
  pickupArrivedAt?: Maybe<Scalars['String']>
  pickupCity: Scalars['String']
  pickupIsDrop: Scalars['Boolean']
  pickupStateCode: Scalars['String']
  pickupTimezone?: Maybe<Scalars['String']>
  pickupTrailerArrivedAt?: Maybe<Scalars['String']>
  pickupTrailerEmptiedAt?: Maybe<Scalars['String']>
  state: Scalars['String']
}

export type ITrailerShipperFacility = {
  __typename?: 'TrailerShipperFacility'
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
  uuid: Scalars['String']
}

export enum ITrailerStatesInputEnum {
  /** INACTIVE */
  inactive = 'inactive',
  /** UNASSIGNED */
  unassigned = 'unassigned',
}

export type ITransfixHighwayInsurancePolicyFlag = {
  __typename?: 'TransfixHighwayInsurancePolicyFlag'
  createdAt: Scalars['ISO8601DateTime']
  id?: Maybe<Scalars['ID']>
  transfixAdditionalInsured: Scalars['Boolean']
  transfixAdditionalInsuredUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>
  transfixAdditionalInsuredUpdatedById?: Maybe<Scalars['ID']>
  transfixHolder: Scalars['Boolean']
  transfixHolderUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>
  transfixHolderUpdatedById?: Maybe<Scalars['ID']>
  transfixLossPayee: Scalars['Boolean']
  transfixLossPayeeUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>
  transfixLossPayeeUpdatedById?: Maybe<Scalars['ID']>
  updatedAt: Scalars['ISO8601DateTime']
}

export type ITruck = {
  __typename?: 'Truck'
  /** CreatedAt timestamp in UTC */
  createdAt: Scalars['ISO8601DateTime']
  entityId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  keepTruckinId?: Maybe<Scalars['ID']>
  motorCarrierId: Scalars['String']
  truckNumber: Scalars['String']
  /** UpdatedAt timestamp in UTC */
  updatedAt: Scalars['ISO8601DateTime']
  vin?: Maybe<Scalars['String']>
}

export type ITruckLocationInput = {
  altitude?: Maybe<Scalars['Float']>
  batteryLevel?: Maybe<Scalars['Float']>
  batteryState?: Maybe<Scalars['String']>
  course?: Maybe<Scalars['Float']>
  horizontalAccuracy?: Maybe<Scalars['Float']>
  latitude: Scalars['Float']
  longitude: Scalars['Float']
  lowPowerMode?: Maybe<Scalars['Boolean']>
  offline?: Maybe<Scalars['Boolean']>
  osTimestamp?: Maybe<Scalars['ISO8601DateTime']>
  phoneModel?: Maybe<Scalars['String']>
  phoneOs?: Maybe<Scalars['String']>
  phoneTimestamp: Scalars['ISO8601DateTime']
  sourceType?: Maybe<Scalars['String']>
  speed?: Maybe<Scalars['Float']>
  totalMemory?: Maybe<Scalars['Int']>
  transfixVersion?: Maybe<Scalars['String']>
  verticalAccuracy?: Maybe<Scalars['Float']>
}

/** Autogenerated input type of UpdateDriverSmsSettings */
export type IUpdateDriverSmsSettingsInput = {
  cellPhone?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  driverId: Scalars['ID']
  shipmentId?: Maybe<Scalars['ID']>
  shipmentSmsStatusUpdatesEnabled?: Maybe<Scalars['Boolean']>
  smsStatusUpdatesEnabled?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of UpdateDriverSmsSettings */
export type IUpdateDriverSmsSettingsPayload = {
  __typename?: 'UpdateDriverSmsSettingsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  driver?: Maybe<IDriver>
  errors?: Maybe<Array<IError>>
}

/** Autogenerated input type of UpdateMotorCarrierCertification */
export type IUpdateMotorCarrierCertificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  code: ICertificationCode
  isVerified?: Maybe<Scalars['Boolean']>
  issuingOrganization?: Maybe<Scalars['String']>
  motorCarrierId: Scalars['ID']
  renewalDate?: Maybe<Scalars['ISO8601Date']>
}

/** Autogenerated return type of UpdateMotorCarrierCertification */
export type IUpdateMotorCarrierCertificationPayload = {
  __typename?: 'UpdateMotorCarrierCertificationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  motorCarrier?: Maybe<IMotorCarrier>
}

/** Autogenerated input type of UpdateMotorCarrierCompanyInformation */
export type IUpdateMotorCarrierCompanyInformationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  ein: Scalars['String']
  entityType: IMotorCarrierEntityTypesEnum
  location: ILocationInput
  motorCarrierId: Scalars['ID']
}

/** Autogenerated return type of UpdateMotorCarrierCompanyInformation */
export type IUpdateMotorCarrierCompanyInformationPayload = {
  __typename?: 'UpdateMotorCarrierCompanyInformationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  motorCarrier?: Maybe<IMotorCarrier>
}

/** Autogenerated input type of UpdateMotorCarrierDedicatedLaneRatePreference */
export type IUpdateMotorCarrierDedicatedLaneRatePreferenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  isInterestedInDedicatedLanes?: Maybe<Scalars['Boolean']>
  minimumRatePerMile?: Maybe<Scalars['Float']>
  motorCarrierId: Scalars['ID']
}

/** Autogenerated return type of UpdateMotorCarrierDedicatedLaneRatePreference */
export type IUpdateMotorCarrierDedicatedLaneRatePreferencePayload = {
  __typename?: 'UpdateMotorCarrierDedicatedLaneRatePreferencePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  motorCarrier?: Maybe<IMotorCarrier>
}

/** Autogenerated input type of UpdateMotorCarrierEndorsements */
export type IUpdateMotorCarrierEndorsementsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  endorsements: Array<Scalars['String']>
  motorCarrierId: Scalars['ID']
}

/** Autogenerated return type of UpdateMotorCarrierEndorsements */
export type IUpdateMotorCarrierEndorsementsPayload = {
  __typename?: 'UpdateMotorCarrierEndorsementsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  motorCarrier?: Maybe<IMotorCarrier>
}

/** Autogenerated input type of UpdateMotorCarrierEquipmentCapability */
export type IUpdateMotorCarrierEquipmentCapabilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  isDryVanCapable?: Maybe<Scalars['Boolean']>
  isFlatbedCapable?: Maybe<Scalars['Boolean']>
  isReeferCapable?: Maybe<Scalars['Boolean']>
  isTrailerOnly?: Maybe<Scalars['Boolean']>
  motorCarrierId: Scalars['ID']
  powerUnitCount?: Maybe<Scalars['Int']>
  trailerCount?: Maybe<Scalars['Int']>
}

/** Autogenerated return type of UpdateMotorCarrierEquipmentCapability */
export type IUpdateMotorCarrierEquipmentCapabilityPayload = {
  __typename?: 'UpdateMotorCarrierEquipmentCapabilityPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  motorCarrier?: Maybe<IMotorCarrier>
}

/** Autogenerated input type of UpdateMotorCarrierExcludedCommodities */
export type IUpdateMotorCarrierExcludedCommoditiesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  excludedCommodities: Array<Scalars['String']>
  motorCarrierId: Scalars['ID']
}

/** Autogenerated return type of UpdateMotorCarrierExcludedCommodities */
export type IUpdateMotorCarrierExcludedCommoditiesPayload = {
  __typename?: 'UpdateMotorCarrierExcludedCommoditiesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  motorCarrier?: Maybe<IMotorCarrier>
}

/** Autogenerated input type of UpdateMotorCarrierFreightCapability */
export type IUpdateMotorCarrierFreightCapabilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  isDrayageCapable?: Maybe<Scalars['Boolean']>
  isFtlCapable?: Maybe<Scalars['Boolean']>
  isIntermodalCapable?: Maybe<Scalars['Boolean']>
  isLtlCapable?: Maybe<Scalars['Boolean']>
  motorCarrierId: Scalars['ID']
}

/** Autogenerated return type of UpdateMotorCarrierFreightCapability */
export type IUpdateMotorCarrierFreightCapabilityPayload = {
  __typename?: 'UpdateMotorCarrierFreightCapabilityPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  motorCarrier?: Maybe<IMotorCarrier>
}

/** Autogenerated input type of UpdateMotorCarrierLoadingCapability */
export type IUpdateMotorCarrierLoadingCapabilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  isDropCapable?: Maybe<Scalars['Boolean']>
  isHeavyLoadCapable?: Maybe<Scalars['Boolean']>
  isLiveCapable?: Maybe<Scalars['Boolean']>
  isPowerOnly?: Maybe<Scalars['Boolean']>
  motorCarrierId: Scalars['ID']
}

/** Autogenerated return type of UpdateMotorCarrierLoadingCapability */
export type IUpdateMotorCarrierLoadingCapabilityPayload = {
  __typename?: 'UpdateMotorCarrierLoadingCapabilityPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  motorCarrier?: Maybe<IMotorCarrier>
}

/** Autogenerated input type of UpdateMotorCarrierRateTypePreference */
export type IUpdateMotorCarrierRateTypePreferenceInput = {
  allowsAllIn?: Maybe<Scalars['Boolean']>
  allowsDayRate?: Maybe<Scalars['Boolean']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  hasLineHaulFuelSurcharge?: Maybe<Scalars['Boolean']>
  motorCarrierId: Scalars['ID']
}

/** Autogenerated return type of UpdateMotorCarrierRateTypePreference */
export type IUpdateMotorCarrierRateTypePreferencePayload = {
  __typename?: 'UpdateMotorCarrierRateTypePreferencePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  motorCarrier?: Maybe<IMotorCarrier>
}

/** Autogenerated input type of UpdateMotorCarrierSmartWayRegistration */
export type IUpdateMotorCarrierSmartWayRegistrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  isRegistered: Scalars['Boolean']
  motorCarrierId: Scalars['ID']
  renewalDate?: Maybe<Scalars['ISO8601Date']>
}

/** Autogenerated return type of UpdateMotorCarrierSmartWayRegistration */
export type IUpdateMotorCarrierSmartWayRegistrationPayload = {
  __typename?: 'UpdateMotorCarrierSmartWayRegistrationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  motorCarrier?: Maybe<IMotorCarrier>
}

/** Autogenerated input type of UpdateMotorCarrierTransfixRulesAssessments */
export type IUpdateMotorCarrierTransfixRulesAssessmentsInput = {
  bcaActivated?: Maybe<Scalars['Boolean']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  hasVerifiedAdmin?: Maybe<Scalars['Boolean']>
  motorCarrierId: Scalars['ID']
  w9Uploaded?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of UpdateMotorCarrierTransfixRulesAssessments */
export type IUpdateMotorCarrierTransfixRulesAssessmentsPayload = {
  __typename?: 'UpdateMotorCarrierTransfixRulesAssessmentsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  transfixRulesAssessments?: Maybe<Array<IMotorCarrierTransfixRulesAssessment>>
}

export type IUpdateRulesAssessmentOverride = {
  result: IRulesAssessmentOverrideResultEnum
  rulesAssessmentId: Scalars['ID']
  rulesAssessmentType: IRulesAssessmentOverrideTypeEnum
}

/** Autogenerated input type of UpdateSavedSearch */
export type IUpdateSavedSearchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  deliveryCity?: Maybe<Scalars['String']>
  deliveryEndDate?: Maybe<Scalars['ISO8601Date']>
  deliveryMiles?: Maybe<Scalars['Float']>
  deliveryStartDate?: Maybe<Scalars['ISO8601Date']>
  deliveryStateCode?: Maybe<Scalars['String']>
  dropTrailer?: Maybe<Scalars['Boolean']>
  hasNotificationsEnabled?: Maybe<Scalars['Boolean']>
  hasPushNotificationsEnabled?: Maybe<Scalars['Boolean']>
  loadedMilesMax?: Maybe<Scalars['Float']>
  loadedMilesMin?: Maybe<Scalars['Float']>
  motorCarrierId?: Maybe<Scalars['ID']>
  pickupCity?: Maybe<Scalars['String']>
  pickupEndDate?: Maybe<Scalars['ISO8601Date']>
  pickupIsoDaysOfWeek?: Maybe<Array<Scalars['Int']>>
  pickupMiles?: Maybe<Scalars['Float']>
  pickupStartDate?: Maybe<Scalars['ISO8601Date']>
  pickupStateCode?: Maybe<Scalars['String']>
  rate?: Maybe<Scalars['Float']>
  rateType?: Maybe<Scalars['String']>
  savedSearchId: Scalars['ID']
  trailerType?: Maybe<Scalars['String']>
}

/** Autogenerated return type of UpdateSavedSearch */
export type IUpdateSavedSearchPayload = {
  __typename?: 'UpdateSavedSearchPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  savedSearch?: Maybe<ISavedSearch>
}

/** Autogenerated input type of UpdateTrailer */
export type IUpdateTrailerInput = {
  assignedFacilityUuid?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  emptiedAt?: Maybe<Scalars['ISO8601DateTime']>
  marketplaceTrailerId: Scalars['ID']
  note?: Maybe<Scalars['String']>
  shipmentId?: Maybe<Scalars['ID']>
  state?: Maybe<ITrailerStatesInputEnum>
}

/** Autogenerated return type of UpdateTrailer */
export type IUpdateTrailerPayload = {
  __typename?: 'UpdateTrailerPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  trailer?: Maybe<ITrailer>
}

/** Autogenerated input type of UpdateTransfixHighwayInsurancePolicyFlag */
export type IUpdateTransfixHighwayInsurancePolicyFlagInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  currentUserId: Scalars['ID']
  highwayInsurancePolicyId: Scalars['ID']
  transfixAdditionalInsured?: Maybe<Scalars['Boolean']>
  transfixHolder?: Maybe<Scalars['Boolean']>
  transfixLossPayee?: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of UpdateTransfixHighwayInsurancePolicyFlag */
export type IUpdateTransfixHighwayInsurancePolicyFlagPayload = {
  __typename?: 'UpdateTransfixHighwayInsurancePolicyFlagPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  highwayInsurancePolicy?: Maybe<IHighwayInsurancePolicy>
}

/** Autogenerated input type of UploadW9Form */
export type IUploadW9FormInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  motorCarrierId: Scalars['ID']
  w9FormParams: IAttachableFileInput
}

/** Autogenerated return type of UploadW9Form */
export type IUploadW9FormPayload = {
  __typename?: 'UploadW9FormPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success: Scalars['Boolean']
}

export enum IUserRoleEnum {
  /** ADMIN */
  admin = 'admin',
  /** EMPLOYEE */
  employee = 'employee',
}

export enum IUserTypeEnum {
  /** DISPATCHER */
  dispatcher = 'dispatcher',
  /** DRIVER */
  driver = 'driver',
  /** OWNER_OPERATOR */
  owner_operator = 'owner_operator',
}

/** Autogenerated input type of VerifyUserAccount */
export type IVerifyUserAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  password?: Maybe<Scalars['String']>
  phoneCode?: Maybe<Scalars['String']>
}

/** Autogenerated return type of VerifyUserAccount */
export type IVerifyUserAccountPayload = {
  __typename?: 'VerifyUserAccountPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<IError>
  success?: Maybe<Scalars['Boolean']>
}
